import { Component, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { BaseCommpont } from './../../../../../utils/BaseCommpont';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpHelpUtils } from '../../../../../utils/HttpHelpUtils';
import { RegExUtils } from '../../../../../utils/RegExUtils';
import { ConfirmationService } from 'primeng/api';
import { MessageSub } from './../../../../../utils/MessageSub';
import { Router, ActivatedRoute } from "@angular/router";
import { emptyDataTrigger, filterTrigger, serachTrigger } from '../../../../../utils/Animations';
import StatusUtils from './../../../../../utils/StatusUtils';
import { LocalStorage } from '../../../../../utils/LocalStorage';
import { OssFileService } from './../../../../../components/oss-file/oss-file.service';
import { ImagePreviewService } from './../../../../../components/image-viewer/image-preview.service';
import { DomSanitizer } from '@angular/platform-browser';

declare var ResizeObserver;
@Component({
	selector: 'app-truck',
	templateUrl: './truck.component.html',
	styleUrls: ['./truck.component.scss'],
	providers: [ConfirmationService],
	animations: [emptyDataTrigger, filterTrigger, serachTrigger]
})
export class TruckComponent extends BaseCommpont implements OnInit, AfterViewInit {
	value = '';
	searchForm : FormGroup;                                             // 查询表单
	lockTeamForm : FormGroup;                                           // 锁定车辆车主收款

	openOrderQRCode : boolean;
	regExUtils = new RegExUtils();                                  // 校验规则
	batchPlateNumberDialog = false;                           //批量车牌号弹窗
	batchNoForm : FormGroup;
	vehicle_license_photo_url = '';
	business_certificate_photo_url = '';
	opt_cert_photo_url = '';
	searchShipperList = [];
	agentMap = {};
	searchAgentList = [];
	shipperMap = {};
	editAddressForm : FormGroup;                     // 查询表单
	searchTenantIdList = [];                        // 查询公司列表
	tenantIdList = [];
	validateTramTruckForm : FormGroup;
	checksTruckForm : FormGroup;
	checkWaybillForm : FormGroup;
	buttonAuthForm : FormGroup;                        // 编辑菜单按钮
	first = 0;                                      // 当前列表序号
	editOrderFlag : boolean;                        // 编辑订单下单弹窗
	vehicleTypeList = [];                             // 车辆类型列表
	validateRelDriverForm : FormGroup;           //车辆关联托运方表单
	editIdCardDialogFlag = false;
	validateRelTruckForm : FormGroup;           //车辆关联区域合伙人表单
	editTruckDialogFlag = false;
	flag = 0;
	ShipperList = [];
	vehicleTypeMap = {}
	modeMap = {};
	modelList = [];                                  //车辆品牌
	agentIdList = [];//代理商
	shipperIdList = [];                             //托运方姓名列表
	teamIdList = [];//车主ID
	editColumnDialog = false;                       // 编辑列顺序
	tenantMap = {};                                           // 公司名称
	noCheckWaybillDialogFlag = false;
	checksTruckDialog = false;
	searchDropDown : { [key : string] : [] } = {};      // 初始化查询表单
	editDialogType = 1;
	goodsNameList = [];//货物名称
	lockTeamDialog = false;                                               // 锁定车辆车主为收款人弹窗

	@ViewChild('vehicleLicensePhotoInput') vehicleLicensePhotoInput : ElementRef;        //行驶证主页
	@ViewChild('vehicleLicenseBackPhotoInput') vehicleLicenseBackPhotoInput : ElementRef;        //行驶证副页
	@ViewChild('businessCertificateInput') businessCertificateInput : ElementRef;        //经营许可证
	@ViewChild('optCertPhotoFileInput') optCertPhotoFileInput : ElementRef;        //道路运输证
	@ViewChild('vehicleLicenseCheckFileInput') vehicleLicenseCheckFileInput : ElementRef; // 行驶证年审页
	@ViewChild("clearDepartFileUpload") clearDepartFileUpload : ElementRef;      // 编辑公司上传虚拟组件
	idCardFrontUrl;//身份证正面
	idCardBackUrl;//身份证反面
	drivingLicensePhotoUrl;//驾驶证照片
	@ViewChild('idCardFrontInput') idCardFrontInput : ElementRef;//身份证正面照片清除按钮
	@ViewChild('idCardBackInput') idCardBackInput : ElementRef;//身份证反面照片清除按钮
	@ViewChild('driverTruckInput') driverTruckInput : ElementRef;        //人车证
	@ViewChild('drivingLicensePhotoInput') drivingLicensePhotoInput : ElementRef;//驾驶证照片清除按钮
	@ViewChild('qualificationCertPhotoInput') qualificationCertPhotoInput : ElementRef;        // 上传司机数据虚拟按钮
	@ViewChild('importfileUpload') basicfileUpload : ElementRef;        // 上传司机数据虚拟按钮
	uploadImg = [];
	importDialog = false;                                                           // 导入弹窗
	departUploadFileList = [];
	truckSourceList = [];  // 车辆来源下拉列表
	plateColorLists = []; //车牌颜色
	energyTypeLists = [];//车辆能源类型
	isPersonalLists = [];//车辆属性
	useCharacterLists = [];//使用性质
	truckModelLists = [];//车型
	truckSizeLists = [];//车辆尺寸
	plateColorMap = {}; //车牌颜色
	energyTypeMap = {};//车辆能源类型
	isPersonalMap = {};//车辆属性
	useCharacterMap = {};//使用性质
	truckModelMap = {};//车型
	truckSizeMap = {};//车长
	driverTruckPhotoUrl;//人车照

	editDriverIdCardDialogFlag = false;                               // 司机身份证验证
	id_card_no_front_url = '';                                        // 身份证正面
	validateDriverTruckForm : FormGroup;                                // 司机表单
	validateFormPhone : FormGroup;                                     // 验证司机身份证表单
	identifyIdCardFrontUrl = '';                                      // 验证司机身份证正面照片
	driverTypeList = [];                          //准假车型
	driverTypeMap = {};
	plateNumberList = [];
	plateNumberMap = {};
	teamMap = {};
	teamIdMap = {};
	teamList = [];
	teamTruckDialogFlag = false;
	validateRelTeamTruckForm : FormGroup;
	saveBankUpload = this.httpHelp.checkFullPath('member/driverMan/saveBankUploadFile')
	saveIdCardUrl = this.httpHelp.checkFullPath('member/driverMan/saveIdCardUploadFile')
	uploadItems = [                                                   // 单独传证件
		{ uploadFileTitle: '身份证正面', uploadType: 'id_card_front', uploadSubHeader: '' },
		{ uploadFileTitle: '身份证反面', uploadType: 'id_card_back', uploadSubHeader: '' },
		{ uploadFileTitle: '驾驶证照片', uploadType: 'driver_license', uploadSubHeader: '' },
	];
	qualificationCertPhotoUrl;//司机从业资格证
	politicalOutlookLists = [];//政治面貌
	politicalOutlookMap = {};//政治面貌
	@ViewChild('uploadTruckInput') uploadTruckInput : ElementRef;        // 上传司机数据虚拟按钮

	//关联车主开始
	relTeam = {
		relTeamDialogFlag: false,
		selectedRelTeamList: [],
		relTeamList: [],
		addRelTeamDialogFlag: false,
		teamIdList: []
	};


	uploadFileUrl = {
		vehicleLicensePhotoUrl: '',
		businessCertificatePhotoUrl: '',
		optCertPhotoUrl: '',
		drivingLicensePhotoUrl: '',
		idCardFrontUrl: '',
		idCardBackUrl: '',
		qualificationCertPhotoUrl: ''
	}

	//关联司机开始
	relDriver = {
		relDriverDialogFlag: false,
		selectedrelDriverList: [],
		relDriverList: [],
		addrelDriverDialogFlag: false,
		DriverIdList: []
	};


	constructor(
		private fb : FormBuilder,
		public httpHelp : HttpHelpUtils,
		private el : ElementRef,
		private messageSub : MessageSub,
		private storage : LocalStorage,
		private configSrv : ConfirmationService,
		private ossFileService : OssFileService,
		private imagePreviewService : ImagePreviewService,
		private router : Router,
		 private route: ActivatedRoute,
		private sanitizer : DomSanitizer,
		private MessageSub : MessageSub,

	) {
		super();
	}

	@ViewChild('fileUploadTruck') fileUploadTruck : ElementRef;        // 编辑车辆上传虚拟组件
	@ViewChild('basicTruckUpload') basicTruckUpload : ElementRef;      // 编辑车辆按钮虚拟组件
	validateTruckForm : FormGroup;                                     // 编辑车辆信息表单
	myTruck = {
		plateNumber: '',                                              // 车牌号
		showTruckDetailFlag: false,                                    // 显示车辆详情
		truckDetailHeader: '',                                         // 设置车辆标题
		saveTruckUrl: '',                                              // 保存编辑车辆数据
		uploadTruckName: 'vehLicUploadfile',                           // 上传标识
		tempTruckId: '',                                               // 临时车辆id
		vehicle_license_photo_url: '',                                 // 行驶证照片
		business_certificate_photo_url: '',                            // 经营许可证
		opt_cert_photo_url: '',                                    // 道路运输证照片
		driverTruckPhotoFlag: false,                                   // 上传人车照标识
		truckDetail: [],                                               // 车辆详情
		myTruckListDialogFlag: false,                                  // 我的车辆设置
		trucksDataList: [],                                            // 车辆列表
		selectedTruckList: [],                                         // 选中的车辆数据
		truckEditDialogFlag: false,                                    // 新增车辆基本信息
		truckCheckDialogFlag: false,                                   // 校验车牌号
		uploadTruckPhotoUrl: '',                                       // 上传人车照地址
		checkDriverTruckDialogFlag: false,

	}


	vehicleLicensePhotoUrl;//行驶证主页
	vehicleLicenseBackPhotoUrl;//行驶证副页
	businessCertificatePhotoUrl;//经营性许可证
	optCertPhotoUrl;//道路运输证
	vehicleLicenseCheckPhotoUrl;//行驶证年审页

	editUploadFiles = {                                               // 编辑表单文件上传
		opt_cert_photo: '',
		business_certificate_photo: '',
		vehicle_license_photo: '',
		vehicle_license_back_photo: '',
		id_card_no_front: '',
		id_card_no_back: '',
		driving_license_photo: '',
		driver_truck_photo: '',
		qualification_cert_photo: '',
		vehicle_license_check_photo: '',
	};

	// 状态
	checkFlag = {
		0: "待提交",
		1: "待审核",
		2: "已审核",
		3: "审核不过"
	}
	//审核状态颜色
	getCheckFlag = (val) => {
		if (val == 0) {
			return '#EE9A00';
		} else if (val == 1) {
			return '#B15BFF';
		} else if (val == 2) {
			return '#00A600';
		} else if (val == 3) {
			return '#EA0000';
		}
	}

	statusItems = this.getLocalDropdown(this.checkFlag, true);
	isMemberTruckItem = this.getLocalDropdown({
		0:'网货',
		1:'非网货'
	}, true);
	onlineList = [                                                    // 入网状态
		{ value: 1, label: '查不到入网' },
		{ value: 2, label: '未入网' },
		{ value: 3, label: '已入网' }
	];
	isOnlineMap = {
		1: '查不到入网',
		2: '未入网',
		3: '已入网'
	};

	useStatusList = [
		{ value: '', label: '全部' },                                              // 司机空闲状态
		{ value: 0, label: '空闲' },
		{ value: 1, label: '工作中' },
	];

	useStatus = {                                                     // 使用状态
		0: '空闲',
		1: '工作中'
	};

	queryTypeList = [                                                 // 审核状态
		{ value: '', label: '全部' },
		{ value: 0, label: '待提交' },
		{ value: 1, label: '待审核' },
		{ value: 2, label: '已审核' },
		{ value: 3, label: '审核通过' },
	];

	status = {                                                        // 使用状态
		0: '正常',
		1: '停用',
		2: '注销'
	};

	statusList = [                                                    // 使用状态
		{ value: '', label: '全部' },
		{ value: 0, label: '正常' },
		{ value: 1, label: '停用' },
		{ value: 2, label: '注销' },
	];

	driverType = {                                                    // 使用状态
		'A1': 'A1(大型客车)',
		'A2': 'A2(牵引车)',
		'A3': 'A3(城市公交车)',
		'B1': 'B1(中型客车)',
		'B2': 'B2(大型货车)',
		'C1': 'C1(小型汽车)',
		'C2': 'C2(小型自动挡汽车)',
		'C3': 'C3(低速载货汽车)',
		'C4': 'C4(三轮汽车)'
	};

	sex = {
		1: '男',
		0: '女'
	};
	//来源（0：系统录入，1：数据导入，2：小程序，3：app）
	source = {
		0: '系统录入',
		1: 'EXECL导入',
		2: '微信小程序',
		3: '司机端APP'
	}
	//签署状态,0:待签署，1：签署中，2：签署完成，3：签署失败
	signStatus = {
		0: '待签署',
		1: '签署中',
		2: '已签署',
		3: '签署失败'
	}
	//签署来源
	signSource = {
		1: '网页签署',
		2: '小程序签署',
		3: 'APP签署'
	}
	//是否黑名单
	blacklistStatus = {
		0: '否',
		1: '是'
	}

	// 锁定车主收款状态
	lockTeam = {
		1: '未锁定',
		2: '已锁定'
	}
	reportStatus = {
        0: '无上报',
        1: '未上报',
        2: '上报成功',
        3: '上报失败',
    }
	//查询字段代码格式化
	keysFunction = {                              // 由于方法不能存于缓存，特此添加方法区
		'checkFlag': {
			format: (val, row ?) => { return this.checkFlag[val] },
			colorFormat: (val, row ?) => {
				return StatusUtils.getCheckFlag(val);
			},
		},
		'useStatus': {
			format: (val, row ?) => {
				return this.useStatus[val];
			},
			colorFormat: (val, row ?) => {
				return StatusUtils.getUseStatus(val);
			},
		},
		'vehicleType': {
			format: (val, row ?) => {
				return this.vehicleTypeMap[val];
			}
		},
		'useCharacter': {
			format: (val, row ?) => {
				return this.useCharacterMap[val];
			}
		},
		'model': {
			format: (val, row ?) => {
				return this.modeMap[val];
			}
		},
		'truckSize': {
			format: (val, row ?) => {
				return val && val != 0 ? this.truckSizeMap[val] : '-';
			}
		},
		'agentId': {
			format: (val, row ?) => {
				return this.agentMap[val];
			}
		},
		'cusId': {
			format: (val, row ?) => {
				return this.shipperMap[val];
			}
		},
		'plateColor': {
			format: (val, row ?) => {
				return this.plateColorMap[val];
			}
		},
		'trailerPlateColor': {
			format: (val, row ?) => {
				return this.plateColorMap[val];
			}
		},
		'energyType': {
			format: (val, row ?) => {
				return this.energyTypeMap[val];
			}
		},
		'source': {
			format: (val, row ?) => {
				return this.source[val];
			}
		},
		'teamId': {
			format: (val, row ?) => { return this.teamMap[val]; }
		},

		'energyTypes': {
			format: (val, row ?) => {
				return this.energyTypeMap[row];
			},

		},

		'isPersonal': {
			format: (val, row ?) => {
				return this.isPersonalMap[val];
			},
			colorFormat: (val, row ?) => {
				return { color: StatusUtils.getIsPersonal(val), fontWeight: '700' };
			}
		},
		'isOnline': {
			format: (val, row ?) => {
				return this.isOnlineMap[val];
			},
			colorFormat: (val, row ?) => {
				return { color: StatusUtils.getIsOnline(val), fontWeight: '700' };
			}
		},
		'optCertExpireTime': {
			format: (val, row ?) => {

				return this.setCreateTime(val * 1000, 'yyyy-MM-dd');
			}
		},
		'memberEffectTime': {
			format: (val, row ?) => {
				return this.setCreateTime(val, 'yyyy-MM-dd');
			}
		},
		'memberExpireTime': {
			format: (val, row ?) => {
				return this.setCreateTime(val, 'yyyy-MM-dd');
			}
		},
		'truckType': {
			format: (val, row ?) => {
				return val && val != 0 ? this.truckModelMap[val] : '-';
			}
		},
		'checkTime': {
			format: (val, row ?) => {
				return this.setCreateTime(val * 1000);
			}
		},
		'businessCertificateExpireTime': {
			format: (val, row ?) => {
				return this.setCreateTime(val * 1000, 'yyyy-MM-dd');
			}
		},
		'registerDate': {
			format: (val, row ?) => {
				if (val == 0 || val < 0) {
					return '';
				} else {
					return this.setCreateTime(val * 1000, 'yyyy-MM-dd');
				}
			}
		},
		'issueDate': {
			format: (val, row ?) => {
				if (val == 0 || val < 0) {
					return '';
				} else {
					return this.setCreateTime(val * 1000, 'yyyy-MM-dd');
				}
			}
		},
		'isMemberTruck':{
			format: (val, row ?) => {
				if(val == 0){
					return '网货';
				}else if(val == 1){
					return '会员/商城';
				}else{
					return '';
				}
			}
		},
		'createTime': {
			format: (val, row ?) => {
				return this.setCreateTime(val * 1000);
			}
		},
		'lockTeam': {
			format: (val, row ?) => {
				return this.lockTeam[val];
			},
			colorFormat: (val, row ?) => {
				return StatusUtils.getCheckFlag(val);
			}
		},
		'reportStatus': {
            format: (val, row?) => {
                return this.reportStatus[val];
            },
			colorFormat: (val, row ?) => {
				return StatusUtils.getReportStatus(val)
			}
        }
	}
	updateColumnFlag = 11154455044;                     // 是否更新当前列表数据标识，列表修改则必须修改此标识
	notPartKey = ',plateNumber,checkFlag,checkTime,checkLog,useStatus,checkLog,checkName,length,source,width,height,loadWeight,fullLoadWeight,trailerVolume,ownCarrierId,truckVin,issuingOrganizations,registerDate,issueDate,optCertExpireTime,businessCertificateExpireTime,';
	keys = [
		{ 'label': '车牌号', 'key': 'plateNumber', 'show': true, 'fix': false, keyTyps: 'orderLink', 'width': '150px' },
		{ 'label': '绑定车辆来源', 'key': 'source', 'show': true, 'format': true, 'width': '150px' },
		// { 'label': '会员等级', 'key': 'memberLevelName', 'show': true, 'fix': false, 'width': '130px' },
		// { 'label': '会员卡号', 'key': 'memberCardNo', 'show': true, 'fix': false, 'width': '130px' },
		// { 'label': '会员生效日期', 'key': 'memberEffectTime', 'show': true, 'fix': false, 'width': '130px' },
		// { 'label': '会员到期日期', 'key': 'memberExpireTime', 'show': true, 'fix': false, 'width': '130px' },
		{ 'label': '业务属性', 'key': 'isMemberTruck', 'show': true,'format': true, 'fix': false, 'width': '160px' },

		{ 'label': '销售人员', 'key': 'saleUserName', 'show': true, 'fix': false, 'width': '160px' },
		{ 'label': '审核状态', 'key': 'checkFlag', 'show': true, keyTyps: 'tag', 'format': true, 'width': '120px' },
		 { 'label': '上报状态', 'key': 'reportStatus', 'show': true, format: true, 'fix': false,keyTyps:'reportStatus', 'width': '110px'},
		  { label: "证件过期", key: "certificateExpiredCount", show: true, fix: false, width: "120px", format: true, keyTyps: "certificateExpiredTag" },
		{ 'label': '使用状态', 'key': 'useStatus', 'show': true, keyTyps: 'tag', 'format': true, 'width': '110px' },
		{ 'label': '车辆类型', 'key': 'vehicleType', 'show': true, 'format': true, 'width': '150px' },
		{ 'label': '车型', 'key': 'truckType', 'show': true, 'width': '100px', 'format': true },
		{ 'label': '审核日志', 'key': 'checkLog', 'show': true, 'width': '200px' },
		{ 'label': '审核人员', 'key': 'checkName', 'show': true, 'width': '130px' },
		{ 'label': '审核时间', 'key': 'checkTime', 'show': true, 'width': '180px', 'format': true },
		{ 'label': '挂车车牌', 'key': 'trailerPlateNumber', 'show': true, 'width': '130px' },
		{ 'label': '挂车车牌颜色', 'key': 'trailerPlateColor', 'show': true, 'format': true, 'width': '130px' },
		{ 'label': '车辆长度', 'key': 'length', 'show': true, 'width': '110px' },
		{ 'label': '车辆宽度', 'key': 'width', 'show': true, 'width': '110px' },
		{ 'label': '车辆高度', 'key': 'height', 'show': true, 'width': '110px' },
		{ 'label': '车辆核载', 'key': 'loadWeight', 'show': true, 'width': '110px' },
		{ 'label': '车辆满载', 'key': 'fullLoadWeight', 'show': true, 'width': '110px' },
		{ 'label': '车辆体积', 'key': 'trailerVolume', 'show': true, 'width': '110px' },
		{ 'label': '车辆品牌', 'key': 'model', 'show': true, 'width': '220px' },
		{ 'label': '车牌颜色', 'key': 'plateColor', 'show': true, 'format': true, 'width': '130px' },
		{ 'label': '车辆能源类型', 'key': 'energyType', 'show': true, 'format': true, 'width': '130px' },
		{ 'label': '业户名称', 'key': 'ownName', 'show': true, 'width': '250px' },
		{ 'label': '车辆属性', 'key': 'isPersonal', 'show': true, 'format': true, 'width': '130px' },
		{ 'label': '业户社会信用代码', 'key': 'ownCarrierId', 'show': true, 'width': '130px' },
		{ 'label': '道路运输证号', 'key': 'optCertNo', 'show': true, 'width': '130px' },
		{ 'label': '道路运输证失效日期', 'key': 'optCertExpireTime', 'show': true, 'format': true, 'width': '180px',keyTyps:'optCertExpireTime' },
		{ 'label': '经营许可证号', 'key': 'businessCertificate', 'show': true, 'width': '120px' },
		{ 'label': '经营许可证失效日期', 'key': 'businessCertificateExpireTime', 'show': true, 'width': '140px', 'format': true },
		{ 'label': '使用性质', 'key': 'useCharacter', 'show': true, 'width': '100px' },
		{ 'label': '车辆识别代码', 'key': 'truckVin', 'show': true, 'width': '180px' },

		{ 'label': '车长', 'key': 'truckSize', 'show': true, 'width': '100px', 'format': true },
		{ 'label': '行驶证发证机关', 'key': 'issuingOrganizations', 'show': true, 'width': '400px' },
		{ 'label': '行驶证注册日期', 'key': 'registerDate', 'show': true, 'width': '120px' },
		
		{ 'label': '行驶证发证日期', 'key': 'issueDate', 'show': true, 'width': '120px' },
		{ 'label': '车辆年检到期日期', 'key': 'vehicleExaminedExpirationDate', 'show': true, 'width': '180px',keyTyps:'vehicleExaminedExpirationDate'},
		{ 'label': '入网状况', 'key': 'isOnline', 'show': true, 'format': true, 'width': '100px', 'colorFormat': true },
		{ 'label': '车主', 'key': 'teamId', 'show': true, 'fix': false, 'width': '190px', 'format': true },
		{ 'label': '备注', 'key': 'remark', 'show': true, 'fix': false, 'width': '190px' },
		{ 'label': '锁定状态', 'key': 'lockTeam', 'show': true, keyTyps: 'tag', 'format': true, 'width': '110px' },
		{ 'label': '创建时间', 'key': 'createTime', 'show': true, 'fix': false, 'width': '190px', 'format': true },
	];
	// -----------------------------------方法区--------------------------------------------------//

	//新增司机关联
	selectedDriver = {};//选择司机信息
	searchDriverList = [];//搜索结果集
	editAgentorRelDriver() {
		this.selectedDriver = {};
		this.validateRelDriverForm.reset();
		this.editIdCardDialogFlag = true;
	}
	  /**
   * 计算传入日期与当前日期相差的天数
   * - 正数：传入日期在当前日期之后
   * - 负数：传入日期在当前日期之前
   * - 0：同一天
   * - ""：非法 / 空值
   */
  getDateDiffInDays(date?: string | number | null,beforeFormat?: boolean): number | "" {
    if (date == null || date === "") {
      return "";
    }
		if(beforeFormat){
			date = this.setCreateTime(Number(date) * 1000, 'yyyy-MM-dd');
		}
    let inputDate: Date;

    // 时间戳（number 或纯数字字符串）
    if (typeof date === "number" || /^\d+$/.test(String(date))) {
      const ts = typeof date === "number" ? date : Number(date);
      inputDate = new Date(ts);
    }
    // YYYY-MM-DD
    else if (/^\d{4}-\d{2}-\d{2}$/.test(String(date))) {
      const parts = String(date).split("-").map(Number);
      const y = parts[0];
      const m = parts[1] - 1; // JS 月份从 0 开始
      const d = parts[2];

      inputDate = new Date(y, m, d);

      // ✅ 拦截非法日期（如 2026-02-30 → 会被自动修正为 3月2日）
      if (inputDate.getFullYear() !== y || inputDate.getMonth() !== m || inputDate.getDate() !== d) {
        return "";
      }
    }
    // 不支持的格式
    else {
      return "";
    }

    if (Number.isNaN(inputDate.getTime())) {
      return "";
    }

    const now = new Date();
    now.setHours(0, 0, 0, 0);

    // 两个日期均为本地时区 00:00:00，无时区偏移问题
    return Math.floor((inputDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
  }
	//保存关联司机信息
	async saveAgentorRelDriver() {
		// let tmpDriver = this.validateRelDriverForm.controls.driverId.value;
		// if(tmpDriver==null || tmpDriver==''){
		//   super.showMessage(this.messageSub,'请选择关联的司机信息！','error');
		//   return;
		// }
		let ids = '';
		// this.selectedItem.forEach(item => {
		//     ids += item.id + ',';
		// });
		// if(ids==''){
		//     ids=this.tempId
		// }

		if (this.flag == 0) {
			ids = this.tempId
		} else {
			this.selectedItem.forEach(item => {
				ids += item.id + ',';
			});
		}


		const that = this;
		const options = {
			truckId: ids,
			shipperId: this.validateRelDriverForm.controls.cusId.value,
		};

		this.httpHelp.loadingBlock = true;
		await this.httpHelp.post('psg/trucks/add-shipper-drivers', options).then(res => {
			this.httpHelp.loadingBlock = false;
			if (res['status'] === this.svrType) {
				this.dialogBlock = false
				that.queryRelDriver();
				this.editIdCardDialogFlag = false;
				this.showMessage(this.messageSub, res['message']);
			} else {
				super.showMessage(this.messageSub, res['message'], 'error');
			}
		}).catch(err => { });
	}

	//删除关联司机
	delRelDriver() {
		let ids = '';
		const that = this;
		that.selectAgentorRelList.forEach(item => {
			ids += item.id + ',';
		});
		this.httpHelp.delete({
			confirm: this.configSrv,
			url: 'psg/trucks/delete-shipper-driver',
			deleteId: ids,
			success: (res) => {
				this.httpHelp.loadingBlock = false;
				if (res['status'] == this.svrType) {
					that.queryRelDriver();
					that.showMessage(that.messageSub, res['message']);
				} else {
					super.showMessage(this.messageSub, res['message'], 'error');
				}
			}
		});
	}


	//已关联司机查询
	relDriverDialogFlag = false;
	dialogRelTitle = '';
	selectAgentorRelList = [];
	relAgentorDriverDataList = [];
	relDriversDialog(res) {
		this.tempId = res.id;
		this.dialogRelTitle = res.plateNumber;
		this.queryRelDriver();
		this.relDriverDialogFlag = true;
	}
	handleReport(res){
        
    }
	relDriversDialog1() {
		this.selectedDriver = {};
		this.validateRelDriverForm.reset();
		this.editIdCardDialogFlag = true;
	}

	//查询车辆关联托运方信息
	relDriverloading = false;
	queryRelDriver() {
		this.selectAgentorRelList = [];
		this.relAgentorDriverDataList = [];
		this.relDriverloading = true;
		this.httpHelp.get('psg/trucks/get-truck-rel-detail', { truckId: this.tempId }).then(res => {
			this.relDriverloading = false;
			if (res['status'] === this.svrType) {
				this.relAgentorDriverDataList = res['data']['relCusList'];
			} else {
				this.showMessage(this.messageSub, res['message'], 'error');
			}
		});
	}

	//已关联司机查询
	relTruckDialogFlag = false;
	selectTruckRelList = [];
	relAgentTruckDataList = [];
	relAgentTruck(res) {
		this.tempId = res.id;
		this.dialogRelTitle = res.plateNumber;
		this.queryRelTruck();
		this.relTruckDialogFlag = true;
	}

	relAgentTruckDialog() {
		this.flag = 1;
		this.selectedTruck = {};
		this.validateRelTruckForm.reset();
		this.editTruckDialogFlag = true;
	}

	//查询车辆关联托运方信息
	relTruckloading = false;
	queryRelTruck() {
		this.selectAgentorRelList = [];
		this.relAgentTruckDataList = [];
		this.relTruckloading = true;
		this.httpHelp.get('psg/trucks/get-truck-rel-detail', { truckId: this.tempId }).then(res => {
			this.relTruckloading = false;
			if (res['status'] === this.svrType) {
				this.relAgentTruckDataList = res['data']['relAgentList'];
			} else {
				this.showMessage(this.messageSub, res['message'], 'error');
			}
		});
	}

	//新增司机关联
	selectedTruck = {};//选择司机信息
	searchTruckList = [];//搜索结果集
	editAgentRelTruck() {
		this.flag = 0;
		this.selectedTruck = {};
		this.validateRelTruckForm.reset();
		this.editTruckDialogFlag = true;
	}

	//保存关联司机信息
	async saveAgentRelTruck() {
		// let tmpDriver = this.validateRelDriverForm.controls.driverId.value;
		// if(tmpDriver==null || tmpDriver==''){
		//   super.showMessage(this.messageSub,'请选择关联的司机信息！','error');
		//   return;
		// }
		let ids = '';
		//  this.selectedItem.forEach(item => {
		//      ids += item.id + ',';
		//  });
		//  if(ids==''){
		//      ids=this.tempId
		//  }

		if (this.flag == 0) {
			ids = this.tempId
		} else {
			this.selectedItem.forEach(item => {
				ids += item.id + ',';
			});
		}


		const that = this;
		const options = {
			truckId: ids,
			agentId: this.validateRelTruckForm.controls.agentId.value,
		};

		this.httpHelp.loadingBlock = true;
		await this.httpHelp.post('psg/trucks/add-agent-truck', options).then(res => {
			this.httpHelp.loadingBlock = false;
			if (res['status'] === this.svrType) {
				if (this.flag == 1) {
					that.queryList();
					this.dialogBlock = false
				} else {
					that.queryRelTruck();
				}

				this.editTruckDialogFlag = false;
				this.showMessage(this.messageSub, res['message']);
			} else {
				super.showMessage(this.messageSub, res['message'], 'error');
			}
		}).catch(err => { });
	}

	relTeamTruckDialog() {
		this.validateRelTeamTruckForm.reset()
		this.getTeam();
		this.teamTruckDialogFlag = true
		this.uploadImg = []
		this.departUploadFileList = []
	}

	async saveTeamRelTruck() {
		let departPhoto = '';
		for (let v = 0; v < this.departUploadFileList.length; v++) {
			if (this.departUploadFileList[v].type == 'upload') {
				departPhoto += this.departUploadFileList[v]['name'] + ',';
			} else {
				await this.ossFileService.uploadOSSFile(this.departUploadFileList[v], this.regExUtils.TEAM).then(res => {
					if (res['status'] == this.svrType) {
						if (v == this.departUploadFileList.length - 1) {
							departPhoto += res['uploadName'];
						} else {
							departPhoto += res['uploadName'] + ',';
						}
					} else {
						this.httpHelp.loadingBlock = false;
						this.showMessage(this.MessageSub, '图片上传失败', 'error');
					}
				});
			}
		}
		if (departPhoto.substr(-1) == ",") {
			departPhoto = departPhoto.substring(0, departPhoto.length - 1);
		}
		for (const i in this.validateRelTeamTruckForm.controls) {
			if (this.validateRelTeamTruckForm.controls[i].invalid) {
				this.validateRelTeamTruckForm.controls[i].markAsDirty();
				this.validateRelTeamTruckForm.controls[i].updateValueAndValidity();
				return;
			}
		}
		let ids = '';
		this.selectedItem.forEach(item => {
			ids += item.id + ',';
		});
		if (ids == '') {
			ids = this.tempId
		}

		const that = this;
		const options = {
			truckId: ids,
			teamId: this.validateRelTeamTruckForm.controls.teamId.value,
			agreementPhoto: departPhoto
		};

		this.httpHelp.loadingBlock = true;
		await this.httpHelp.post('psg/trucks/add-team-truck', options).then(res => {
			this.httpHelp.loadingBlock = false;
			if (res['status'] === this.svrType) {
				this.dialogBlock = false
				that.queryList();
				this.teamTruckDialogFlag = false;
				this.showMessage(this.messageSub, res['message']);
			} else {
				super.showMessage(this.messageSub, res['message'], 'error');
			}
		}).catch(err => { });
	}

	//删除关联司机
	delRelTruck() {
		let ids = '';
		const that = this;
		that.selectTruckRelList.forEach(item => {
			ids += item.id + ',';
		});
		this.httpHelp.delete({
			confirm: this.configSrv,
			url: 'psg/trucks/delete-agent-truck',
			deleteId: ids,
			success: (res) => {
				this.httpHelp.loadingBlock = false;
				if (res['status'] == this.svrType) {
					that.queryRelTruck();
					that.showMessage(that.messageSub, res['message']);
				} else {
					super.showMessage(this.messageSub, res['message'], 'error');
				}
			}
		});
	}


	closeExamDialog() {
		this.showTruckCheckFlag = false;
		// this.queryList();
	}

	changeTableList() {
		this.changeTable = !this.changeTable;
	}

	showDetail(item) {
		item.truckId = item.id;
		this.myTruck.truckDetail = item;
		this.myTruck.showTruckDetailFlag = true;
	}

	// 切换查询状态
	changeSearchStatus(checkValue) {
		let that = this;
		this.statusItems.forEach(e => {
			if (e.value === checkValue) {
				e.checkFlag = true;
			} else {
				e.checkFlag = false;
			}
		});
		this.searchForm.patchValue({
			checkFlag: checkValue
		});
		this.queryList();
	}
	changeIsMemberTruckItemStatus(checkValue,getList = true){
		let that = this;
		this.isMemberTruckItem.forEach(e => {
			if (e.value === checkValue) {
				e.checkFlag = true;
			} else {
				e.checkFlag = false;
			}
		});
		this.searchForm.patchValue({
			isMemberTruck: checkValue
		});
		if(getList){
			 this.queryList();
		}
		console.log("this.isMemberTruckItem",this.isMemberTruckItem);
	}

	// 锁定or解锁车辆车主收款
	toggleLockTeamDialog() {
		this.lockTeamForm.patchValue({
			lockTeam: 1
		});
		this.lockTeamDialog = true;
	}

	// 编辑数据
	editMyTruck(data ?, type ?) {
		this.getTeam();
		if (data) {
			this.tempId = data['id'];
			// this.httpHelp.get('psg/common/get-form-token', {}).then(res => {
			//   if (res['status'] == this.svrType) {
			//     this.formId = res['data']['formId'];
			//     this.formToken = res['data']['formToken'];
			//   } else {

			//   }
			// });
			let tempData = { ...data };
			this.editDialogType = type;
			this.myTruck['plateNumber'] = data['plateNumber']
			
			this.validateTruckForm.patchValue(tempData);
			this.queryTruck();
			console.log(this.validateTruckForm, '888888888888')
		} else {
			this.tempId = '';
			this.myTruck['plateNumber'] = '';
			this.myTruck['truckCheckDialogFlag'] = true;
			this.validateTruckForm.patchValue({
				energyType: this.energyTypeLists[0]
			});
		}
	}

	getTeam() {
		//车主信息
		this.teamIdList = []
		this.httpHelp.get('psg/team/get-team', {}).then(res => {
			if (res['status'] == 'success') {
				const tempShipperIdList = res['data']['pageList'];
				this.teamIdList.push({
					value: '',
					label: '请选择车主',
				})
				tempShipperIdList.forEach(e => {
					this.teamIdList.push({
						label: e['realname'],
						value: e['id']
					});
				});

			} else {
				// this.showMessage()
			}
		});
	}

	verifyButtons(plateNumber ?) {
		let tempValue = '';
		if (plateNumber) {
			tempValue = plateNumber;
		} else {
			tempValue = this.myTruck['plateNumber']
		}

		this.httpHelp.get('psg/trucks/get-plateNumber-list', {
			plateNumber: tempValue
		}).then(res => {
			if (res['status'] == 'success') {
				const tempData = res['data'][0];
				this.httpHelp.get('psg/common/get-form-token', {}).then(res => {
					if (res['status'] == this.svrType) {
						this.formToken = res['data']['formToken'];
						this.formId = res['data']['formId'];
						let patchData = {};
						for (let key in tempData) {
							if (tempData[key]) {
								patchData[key] = tempData[key];
							}
						}
						this.buttonAuthForm.patchValue(patchData);
						this.editDialogFlag = true;
					} else {
						this.showMessage(this.messageSub, res['message'], 'eoor');
					}
				});
			} else {
				this.showMessage(this.messageSub, res['message'], 'eoor');
			}
		});
	}

	// 选择行驶证主页
	async onSelectLicense(event) {
		this.vehicleLicensePhotoUrl = this.sanitizer.bypassSecurityTrustUrl(event['files'][0]['objectURL']['changingThisBreaksApplicationSecurity']);
		this.httpHelp.loadingBlock = true;
		let result = {};
		await this.ossFileService.uploadOSSFile(event['currentFiles'][0], this.regExUtils.TRUCK).then(res => {
			if (res['status'] == this.svrType) {
				result = res;
			} else {
				this.httpHelp.loadingBlock = false;
			}
		});
		this.httpHelp.loadingBlock = false;
		this.vehicleLicensePhotoInput.nativeElement.click();
		this.httpHelp.get('psg/common/analysis-img', {
			folder: this.regExUtils.TRUCK,
			imgName: result['uploadName'],
			fileType: 'vehicle_license_front'
		}).then(res => {
			this.httpHelp.loadingBlock = false;
			if (res['status'] == this.svrType) {

				let issueDate = res['data']['analysisData']['issueDate'];
				if (issueDate.length == 8 && issueDate != undefined) {
					issueDate = issueDate.substring(0, 4) + '-' + issueDate.substring(4, 6) + '-' + issueDate.substring(6, 8);
				} else {
					issueDate = '';
				}
				let registerDate = res['data']['analysisData']['registerDate'];
				if (registerDate.length == 8 && registerDate != undefined) {
					registerDate = registerDate.substring(0, 4) + '-' + registerDate.substring(4, 6) + '-' + registerDate.substring(6, 8);
				} else {
					registerDate = '';
				}

				let vehicleType = this.vehicleTypeList[0]['value'];//准驾车型
				vehicleType = res['data']['analysisData']['vehicleType'];
				if (vehicleType == '' || vehicleType == null) {
					vehicleType = this.driverTypeList[0]['value'];
				} else {
					vehicleType = this.getParamCodes(vehicleType);
				}
				this.validateTruckForm.patchValue({
					vehicleLicensePhoto: result['uploadName'],
					issueDate: issueDate,
					issuingOrganizations: res['data']['analysisData']['issuingOrganizations'],
					model: res['data']['analysisData']['model'],
					//  ownAddress:res['data']['analysisData']['ownAddress'],.
					ownName: res['data']['analysisData']['ownName'],
					plateNumber: res['data']['analysisData']['plateNumber'],
					registerDate: registerDate,
					truckVin: res['data']['analysisData']['truckVin'],
					vehicleType: vehicleType
				});
			} else {
				this.showMessage(this.MessageSub, '请检查照片是否清晰！', 'error');
			}

		});
		// this.validateTruckForm.patchValue({
		//   vehicleLicensePhoto: result['uploadName'],
		// });
		this.editUploadFiles.vehicle_license_photo = this.vehicleLicensePhotoUrl;
	}

	getParamCode(value, compare = (a, b) => a === b) {
		return Object.keys(this.energyTypeMap).find(k => compare(this.energyTypeMap[k], value))
	}
	getParamCodes(value, compare = (a, b) => a === b) {
		return Object.keys(this.vehicleTypeMap).find(k => compare(this.vehicleTypeMap[k], value))
	}

	// 选择行驶证副页
	async onSelectLicenseBack(event) {
		this.vehicleLicenseBackPhotoUrl = this.sanitizer.bypassSecurityTrustUrl(event['files'][0]['objectURL']['changingThisBreaksApplicationSecurity']);
		this.httpHelp.loadingBlock = true;
		let result = {};
		await this.ossFileService.uploadOSSFile(event['currentFiles'][0], this.regExUtils.TRUCK).then(res => {
			if (res['status'] == this.svrType) {
				result = res;
			} else {
				this.httpHelp.loadingBlock = false;
			}
		});
		this.httpHelp.loadingBlock = false;
		this.vehicleLicenseBackPhotoInput.nativeElement.click();
		this.httpHelp.get('psg/common/analysis-img', {
			folder: this.regExUtils.TRUCK,
			imgName: result['uploadName'],
			fileType: 'vehicle_license_back'
		}).then(res => {
			this.httpHelp.loadingBlock = false;
			if (res['status'] == this.svrType) {
				let size = res['data']['analysisData']['size'];
				let a = size.substring(0, size.indexOf('X'));
				let b = size.substring(size.indexOf('X') + 1, size.lastIndexOf('X'));
				let c = size.substring(size.lastIndexOf('X') + 1, size.length - 2);
				let loadWeight = res['data']['analysisData']['loadWeight'];
				let wei = loadWeight.slice(0, -2);
				let energyType = this.energyTypeLists[0]['value'];//
				energyType = res['data']['analysisData']['energyType'];


				if (energyType == '' || energyType == null) {
					energyType = this.energyTypeLists[0]['value'];
				} else {
					energyType = this.getParamCode(energyType);
				}

				this.validateTruckForm.patchValue({
					vehicleLicenseBackPhoto: result['uploadName'],
					energyType: energyType,
					loadWeight: wei,
					fullLoadWeight: res['data']['analysisData']['fullLoadWeight'].slice(0, -2),
					length: a,
					width: b,
					height: c
				});

			} else {
				this.validateTruckForm.patchValue({
					vehicleLicenseBackPhoto: result['uploadName'],
				});
				this.showMessage(this.MessageSub, '请检查照片是否清晰！', 'error');
			}
		});
		// this.validateTruckForm.patchValue({
		//   vehicleLicenseBackPhoto: result['uploadName']
		// });
		this.editUploadFiles.vehicle_license_back_photo = this.vehicleLicenseBackPhotoUrl;
	}

	// 选择经营许可证
	async onSelectCertificate(event) {
		this.businessCertificatePhotoUrl = this.sanitizer.bypassSecurityTrustUrl(event['files'][0]['objectURL']['changingThisBreaksApplicationSecurity']);
		this.httpHelp.loadingBlock = true;
		let result = {};
		await this.ossFileService.uploadOSSFile(event['currentFiles'][0], this.regExUtils.TRUCK).then(res => {
			if (res['status'] == this.svrType) {
				result = res;
			} else {
				this.httpHelp.loadingBlock = false;
			}
		});
		this.httpHelp.loadingBlock = false;
		this.validateTruckForm.patchValue({
			businessCertificatePhoto: result['uploadName']
		});
		this.editUploadFiles.business_certificate_photo = this.businessCertificatePhotoUrl;
	}

	// 选择道路运输证照片
	async onSelectOptCert(event) {
		this.optCertPhotoUrl = this.sanitizer.bypassSecurityTrustUrl(event['files'][0]['objectURL']['changingThisBreaksApplicationSecurity']);
		this.httpHelp.loadingBlock = true;
		let result = {};
		await this.ossFileService.uploadOSSFile(event['currentFiles'][0], this.regExUtils.TRUCK).then(res => {
			if (res['status'] == this.svrType) {
				result = res;
			} else {
				this.httpHelp.loadingBlock = false;
			}
		});
		this.httpHelp.loadingBlock = false;
		this.optCertPhotoFileInput.nativeElement.click();
		this.validateTruckForm.patchValue({
			optCertPhoto: result['uploadName']
		});
		this.editUploadFiles.opt_cert_photo = this.optCertPhotoUrl;
	}

	// 选择车辆年审页照片
	async onSelectVehicleLicenseCheck(event) {
		this.vehicleLicenseCheckPhotoUrl = this.sanitizer.bypassSecurityTrustUrl(event['files'][0]['objectURL']['changingThisBreaksApplicationSecurity']);
		this.httpHelp.loadingBlock = true;
		let result = {};
		await this.ossFileService.uploadOSSFile(event['currentFiles'][0], this.regExUtils.TRUCK).then(res => {
			if (res['status'] == this.svrType) {
				result = res;
			} else {
				this.httpHelp.loadingBlock = false;
			}
		});
		this.httpHelp.loadingBlock = false;
		this.vehicleLicenseCheckFileInput.nativeElement.click();
		this.validateTruckForm.patchValue({
			vehicleLicenseCheckPhoto: result['uploadName']
		});
		this.editUploadFiles.vehicle_license_check_photo = this.vehicleLicenseCheckPhotoUrl;
	}

	//校验车辆信息
	queryTruck() {
		//初始化表单
		this.validateTruckForm.reset();
		if (this.tempId == null || this.tempId == '') {
			if (!this.regExUtils.PLATE_NUMBER_RULE.test(this.myTruck['plateNumber'])) {
				this.showMessage(this.messageSub, '车牌号格式错误,请重新输入！', 'error');
				return;
			}
		}
		this.vehicleLicensePhotoUrl = 'assets/file/image/xsz.png';
		this.vehicleLicenseBackPhotoUrl = 'assets/file/image/xsz.png';
		this.businessCertificatePhotoUrl = 'assets/file/image/dlysz.png';
		this.optCertPhotoUrl = 'assets/file/image/dlysz.png';
		this.driverTruckPhotoUrl = 'assets/file/image/dlysz.png';//人车照片
		this.vehicleLicenseCheckPhotoUrl = 'assets/file/image/xszfy.png';

		this.httpHelp.get('psg/trucks/get-number', {
			truckId: this.tempId,
			plateNumber: this.myTruck['plateNumber']
		}).then(res => {
			console.log("rrrrrr=====",res);
			this.httpHelp.loadingBlock = false;
			this.validateTruckForm.reset();
			if (res['status'] === this.svrType) {
				if (!res['data']) {
					this.validateTruckForm.patchValue({
						plateNumber: this.myTruck['plateNumber'],
						vehicleType: this.vehicleTypeList.length > 0 ? this.vehicleTypeList[0]['value'] : '',
						plateColor: this.plateColorLists.length > 0 ? this.plateColorLists[0]['value'] : '',
						energyType: this.energyTypeLists.length > 0 ? this.energyTypeLists[1]['value'] : '',
						isPersonal: this.isPersonalLists.length > 0 ? this.isPersonalLists[0]['value'] : '',
						useCharacter: this.useCharacterLists.length > 0 ? this.useCharacterLists[0].value : '',
						truckType: this.truckModelLists.length > 0 ? this.truckModelLists[0].value : '',
						truckSize: this.truckSizeLists.length > 0 ? this.truckSizeLists[0].value + '' : '',
						teamId: this.teamIdList.length > 0 ? this.teamIdList[0].value + '' : '',
						
					});
					this.myTruck['truckEditDialogFlag'] = true;
					this.httpHelp.get('psg/common/get-form-token', {}).then(res => {
						if (res['status'] == this.svrType) {
							this.formId = res['data']['formId'];
							this.formToken = res['data']['formToken'];
						} else {

						}
					});
				} else {
					// 处理重复司机数据
					const truckItem = JSON.parse(JSON.stringify(res['data']['truck']));

					console.log(truckItem)
					if (truckItem['registerDate']) {
						truckItem['registerDate'] = this.setCreateTime(truckItem['registerDate'] * 1000, 'yyyy-MM-dd');
					}
					if (truckItem['issueDate']) {
						truckItem['issueDate'] = this.setCreateTime(truckItem['issueDate'] * 1000, 'yyyy-MM-dd');
					}
					if (truckItem['businessCertificateExpireTime']) {
						truckItem['businessCertificateExpireTime'] = this.setCreateTime(truckItem['businessCertificateExpireTime'] * 1000, 'yyyy-MM-dd');
					}
					if (truckItem['optCertExpireTime']) {
						truckItem['optCertExpireTime'] = this.setCreateTime(truckItem['optCertExpireTime'] * 1000, 'yyyy-MM-dd');
					}
					this.validateTruckForm.patchValue(truckItem);
					if (!truckItem['vehicleType']) {
						truckItem['vehicleType'] = this.vehicleTypeList.length > 0 ? this.vehicleTypeList[0]['value'] : '';
					}
					if (!truckItem['plateColor']) {
						truckItem['plateColor'] = this.plateColorLists.length > 0 ? this.plateColorLists[0]['value'] : '';
					}
					if (!truckItem['energyType']) {
						truckItem['energyType'] = this.energyTypeLists.length > 0 ? this.energyTypeLists[0]['value'] : '';
					}
					if (!truckItem['isPersonal']) {
						truckItem['isPersonal'] = this.isPersonalLists.length > 0 ? this.isPersonalLists[0]['value'] : '';
					}
					if (!truckItem['useCharacter']) {
						truckItem['useCharacter'] = this.useCharacterLists.length > 0 ? this.useCharacterLists[0].value : '';
					}
					if (!truckItem['truckType']) {
						truckItem['truckType'] = this.truckModelLists.length > 0 ? this.truckModelLists[0].value : '';
					}
					if (!truckItem['truckSize']) {
						truckItem['truckSize'] = this.truckSizeLists.length > 0 ? this.truckSizeLists[0].value + '' : '';
					}
					this.validateTruckForm.patchValue({
						vehicleType: truckItem['vehicleType'] + '',
						plateColor: truckItem['plateColor'] + '',
						energyType: truckItem['energyType'] + '',
						isPersonal: truckItem['isPersonal'] + '',
						useCharacter: truckItem['useCharacter'] + '',
						truckType: truckItem['truckType'] + '',
						truckSize: truckItem['truckSize'] + '',
						//直接取原始值
						registerDate:res['data']['truck']['registerDate'] + '',
						issueDate:res['data']['truck']['issueDate'] + '',
					});
					
					// 查询预览图片
					if (truckItem.vehicleLicensePhoto) {
						this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, truckItem.vehicleLicensePhoto).then(res => {
							if (res['status'] == this.svrType) {
								this.vehicleLicensePhotoUrl = res['data']['url'];
							}
						});
					}
					if (truckItem.vehicleLicenseBackPhoto) {
						this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, truckItem.vehicleLicenseBackPhoto).then(res => {
							if (res['status'] == this.svrType) {
								this.vehicleLicenseBackPhotoUrl = res['data']['url'];
							}
						});
					}
					if (truckItem.businessCertificatePhoto) {
						this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, truckItem.businessCertificatePhoto).then(res => {
							if (res['status'] == this.svrType) {
								this.businessCertificatePhotoUrl = res['data']['url'];
							}
						});
					}
					if (truckItem.optCertPhoto) {
						this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, truckItem.optCertPhoto).then(res => {
							if (res['status'] == this.svrType) {
								this.optCertPhotoUrl = res['data']['url'];
							}
						});
					}
					if (truckItem.vehicleLicenseCheckPhoto) {
						this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, truckItem.vehicleLicenseCheckPhoto).then(res => {
							if (res['status'] == this.svrType) {
								this.vehicleLicenseCheckPhotoUrl = res['data']['url'];
							}
						});
					}
				}
			} else {
				super.showMessage(this.messageSub, res['message'], 'error');
			}
		});
		this.myTruck['truckEditDialogFlag'] = true;
	};

	// 检查是否为牵引车类型
	isTractorVehicleType(): boolean {
		const vehicleTypeValue = this.validateTruckForm?.get('vehicleType')?.value;
		if (!vehicleTypeValue) {
			return false;
		}
		const vehicleTypeName = this.vehicleTypeMap[vehicleTypeValue];
		return vehicleTypeName && vehicleTypeName.includes('牵引车');
	}

	// 校验车辆新增表单，以及图片是否上传
	saveTruck() {
		// 检查牵引车类型时,挂车车牌号码和颜色必填
		if (this.isTractorVehicleType()) {
			const trailerPlateNumber = this.validateTruckForm.get('trailerPlateNumber')?.value;
			const trailerPlateColor = this.validateTruckForm.get('trailerPlateColor')?.value;
			
			if (!trailerPlateNumber || trailerPlateNumber.trim() === '') {
				this.showMessage(this.messageSub, '牵引车类型必须填写挂车车牌号码', 'error');
				this.validateTruckForm.get('trailerPlateNumber')?.markAsDirty();
				this.validateTruckForm.get('trailerPlateNumber')?.updateValueAndValidity();
				return;
			}
			
			if (trailerPlateColor === null || trailerPlateColor === undefined || trailerPlateColor === '') {
				this.showMessage(this.messageSub, '牵引车类型必须选择挂车车牌颜色', 'error');
				this.validateTruckForm.get('trailerPlateColor')?.markAsDirty();
				this.validateTruckForm.get('trailerPlateColor')?.updateValueAndValidity();
				return;
			}
		}

		for (const i in this.validateTruckForm.controls) {
			if (this.validateTruckForm.controls[i].invalid) {
				this.validateTruckForm.controls[i].markAsDirty();
				this.validateTruckForm.controls[i].updateValueAndValidity();
				return;
			}
		}
		this.configSrv.confirm({
			message: '确定保存车辆信息吗',
			icon: 'pi pi-exclamation-triangle',
			header: '保存确认',
			acceptLabel: '确定',
			rejectLabel: '取消',
			rejectButtonStyleClass: 'p-button-raised p-button-text p-button-plain',
			accept: () => {
				this.httpHelp.loadingBlock = true;
				this.saveUploadDriverTruck();
			},
			reject: () => {

			},
			key: 'confirm'
		});
	}

	async saveUploadDriverTruck() {
		if (this.vehicleLicensePhotoUrl == 'assets/file/image/xsz.png') {
			this.httpHelp.loadingBlock = false;
			super.showMessage(this.messageSub, '请上传车辆行驶证主页！', 'error');
			return;
		}
		// if (this.vehicleLicenseBackPhotoUrl == 'assets/file/image/xsz.png') {
		//   this.httpHelp.loadingBlock = false;
		//   super.showMessage(this.messageSub, '请上传车辆行驶证！', 'error');
		//   return;
		// }
		if (this.editUploadFiles.business_certificate_photo != '') {

		}
		if (this.optCertPhotoUrl == 'assets/file/image/dlysz.png') {
			this.httpHelp.loadingBlock = false;
			super.showMessage(this.messageSub, '请上传道路运输证！', 'error');
			return;
		}
		const that = this;
		let url = 'add-trucks'
		if (that.tempId) {
			url = 'update-trucks-new' 
		}
		const options = {
			id: that.tempId,
			token: this.formToken,
			formId: this.formId
		};
		this.httpHelp.loadingBlock = false;
		for (const i in this.validateTruckForm.controls) {
			if (this.validateTruckForm.controls[i].invalid) {
				this.validateTruckForm.controls[i].markAsDirty();
				this.validateTruckForm.controls[i].updateValueAndValidity();
				return;
			}
			options[i] = this.validateTruckForm.controls[i].value;
		}

		await this.httpHelp.post('psg/trucks/' + url, options).then(res => {
			this.httpHelp.loadingBlock = false;
			if (res['status'] === this.svrType) {
				this.dialogBlock = false;
				that.queryList();
				that.myTruck['truckEditDialogFlag'] = false;
				that.myTruck['truckCheckDialogFlag'] = false;
				super.showMessage(this.messageSub, res['message']);
			} else {
				super.showMessage(this.messageSub, res['message'], 'error');
			}
		}).catch(err => { });
	}

	// 选择车辆证件图片
	onSelectTruckFile(event, cardType) {
		if (cardType == 'vehicle_license_photo') {
			this.myTruck['vehicle_license_photo_url'] = event['files'][0]['objectURL']['changingThisBreaksApplicationSecurity'];
			this.editUploadFiles.vehicle_license_photo = event['files'][0];
		} else if (cardType == 'business_certificate_photo') {
			this.myTruck['business_certificate_photo_url'] = event['files'][0]['objectURL']['changingThisBreaksApplicationSecurity'];
			this.editUploadFiles.business_certificate_photo = event['files'][0];
		} else if (cardType == 'opt_cert_photo') {
			this.myTruck['opt_cert_photo_url'] = event['files'][0]['objectURL']['changingThisBreaksApplicationSecurity'];
			this.editUploadFiles.opt_cert_photo = event['files'][0];
		} else if (cardType == 'driver_truck_photo') {
			this.myTruck['driver_truck_photo_url'] = event['files'][0]['objectURL']['changingThisBreaksApplicationSecurity'];
			this.editUploadFiles.driver_truck_photo = event['files'][0];
			this.uploadTruckInput.nativeElement.click();
		}
	}

	// 查询列表数据
	queryList(events ?) : void {

		const that = this;
		let httpOptions = {};
		for (const i in this.searchForm.controls) {
			httpOptions[i] = that.searchForm.controls[i].value;
		}
		if (events) {
			this.currentEvent = events;
			this.first = events['first'];
		} else {
			this.currentEvent = {
				first: 0,
				page: 0,
				rows: that.currentEvent['rows'] ? that.currentEvent['rows'] : that.defaultRows
			};
		}
		httpOptions = {
			...httpOptions,
			...this.currentEvent,
		};
		that.loadingNum = 0;

		this.httpHelp.get('psg/trucks/page-trucks', httpOptions).then(res => {
			if (res['status'] == 'success') {
				that.tenantIdList = [];
				this.loadingNum = res['data']['total'];
				if (that.loadingNum == 0) {
					this.emptyData = !this.emptyData;
				}
				that.listOfData = res['data']['records'];
				that.totalNum = res['data']['total'];
				that.first = that.currentEvent['first'];
				that.selectedItem = [];
				super.reloadScroll(this.el);
			} else {
				this.showMessage(this.messageSub, res['message'], 'error');
			}
		});
	}

	exportDialog = false;
	exportForm : FormGroup; // 导出
	// 导出弹窗
	exportCheckExcel() {
		this.exportForm.patchValue({
			exportTemplateType: 1
		})
		this.exportDialog = true;
	}
	// 导出数据
	exportExcel() {
		const httpOptions = {};
		if (this.exportForm.get('exportTemplateType').value == 1) {
			for (const i in this.searchForm.controls) {
				httpOptions[i] = this.searchForm.controls[i].value;
			}
		} else if (this.exportForm.get('exportTemplateType').value == 2) {
			let ids = '';
			this.selectedItem.forEach(e => {
				ids += e['id'] + ',';
			});
			httpOptions['ids'] = ids;
		}

		httpOptions['exportTemplateType'] = this.exportForm.get('exportTemplateType').value;
		this.httpHelp.loadingBlock = true;
		this.httpHelp.get('psg/trucks/export-trucks-data', httpOptions).then(res => {
			this.httpHelp.loadingBlock = false;
			if (res['status'] == this.svrType) {
				super.downFile(res['data']['downFileUrl'], res['data']['downFileName']);
				this.exportDialog = false;
				this.dialogBlock = false
			} else {
				this.showMessage(this.messageSub, res['message'], 'error');
			}
		});
	}

	// 证件导出
	exportTruckCertificates() {
		// 检查是否有选中的项
		if (!this.selectedItem || this.selectedItem.length === 0) {
			this.showMessage(this.messageSub, '请先选择要导出证件的车辆', 'warn');
			return;
		}

		// 收集选中车辆的id
		const ids = this.selectedItem.map(item => item.id);

		this.httpHelp.loadingBlock = true;
		
		// 使用POST请求，但需要特殊处理二进制响应
		const url = this.httpHelp.checkFullPath('psg/trucks/export-truck-certificates');
		
		this.httpHelp.http.post(url, { ids: ids }, { responseType: 'blob', observe: 'response' }).subscribe(
			(response: any) => {
				this.httpHelp.loadingBlock = false;
				
				// 检查响应类型，判断是错误还是成功
				if (response.body.type === 'application/json') {
					// 如果返回的是JSON，说明是错误响应
					const reader = new FileReader();
					reader.onload = () => {
						try {
							const errorResponse = JSON.parse(reader.result as string);
							// 显示后端返回的错误消息
							this.showMessage(this.messageSub, errorResponse.message || '证件导出失败', 'error');
						} catch (e) {
							this.showMessage(this.messageSub, '证件导出失败', 'error');
						}
					};
					reader.readAsText(response.body);
				} else {
					// 如果是二进制文件，说明是成功响应
					const blob = response.body;
					const downloadUrl = window.URL.createObjectURL(blob);
					const a = document.createElement('a');
					a.href = downloadUrl;
					a.download = '车辆证件_' + new Date().getTime() + '.zip';
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
					window.URL.revokeObjectURL(downloadUrl);
					
					this.showMessage(this.messageSub, `已成功导出${ids.length}辆车的证件`, 'success');
				}
			},
			(error) => {
				this.httpHelp.loadingBlock = false;
				
				// 处理HTTP错误响应
				if (error.error instanceof Blob) {
					const reader = new FileReader();
					reader.onload = () => {
						try {
							const errorResponse = JSON.parse(reader.result as string);
							// 显示后端返回的错误消息
							this.showMessage(this.messageSub, errorResponse.message || '证件导出失败', 'error');
						} catch (e) {
							this.showMessage(this.messageSub, '证件导出失败', 'error');
						}
					};
					reader.readAsText(error.error);
				} else {
					console.error('证件导出失败:', error);
					this.showMessage(this.messageSub, error.error?.message || '证件导出失败', 'error');
				}
			}
		);
	}

	// 批量审核数据
	checks() : void {
		let ids = '';
		const that = this;
		let flag = false;
		that.selectedItem.forEach(item => {
			ids += item.id + ',';
			if (item.checkFlag != 1) {
				flag = true;
			}
		});
		if (flag) {
			this.showMessage(this.messageSub, '选中数据已审核结束，不能重复审核', 'error');
			return;
		}
		that.httpHelp.check({
			url: 'psg/trucks/checks-trucks',
			deleteId: ids,
			confirm: that.configSrv,
			success: (res) => {
				this.httpHelp.loadingBlock = false;
				if (res['status'] == 'success') {
					that.queryList();
				}
			}
		});
	}

	//审核数据
	check() : void {
		const that = this;
		that.httpHelp.delete({
			url: 'psg/trucks/check-trucks',
			deleteId: that.tempId,
			confirm: that.configSrv,
			success: (res) => {
				this.httpHelp.loadingBlock = false;
				//that.myTruck['truckEditDialogFlag'] = false;
				if (res['status'] == this.svrType) {
					this.showTruckCheckFlag = false;
					this.showMessage(this.messageSub, res['message']);
					that.queryList();
				} else {
					this.showMessage(this.messageSub, res['message'], 'error');
				}
			},
			confirmMsg: '是否确认审核通过？',
			confirmTitle: '确认审核'
		});
	}

	//
	checkLogSwitch = 0;
	check_waybill_noPass(data) {
		let tempData = { ...data };
		this.checkWaybillForm.reset();
		this.checkLogSwitch = 0;
		this.checkWaybillForm.patchValue({
			checkLogTips: '1',
			checkLog: ''
		});
		this.noCheckWaybillDialogFlag = true;
		this.httpHelp.get('psg/common/get-form-token', {}).then(res => {
			if (res['status'] == this.svrType) {
				this.formToken = res['data']['formToken'];
				this.formId = res['data']['formId'];
				//this.editDialogFlag = true;
			} else {
				this.showMessage(this.messageSub, res['message'], 'eoor');
			}
		});
	}

	//审核不通过理由
	checkLogTipsClick(val) {
		if (val == 4) {
			this.checkLogSwitch = 1;
		} else {
			this.checkLogSwitch = 0;
		}
	}

	//审核不通过
	noCheck() : void {
		const that = this;
		for (const i in that.checkWaybillForm.controls) {
			if (that.checkWaybillForm.controls[i].invalid) {
				that.checkWaybillForm.controls[i].markAsDirty();
				that.checkWaybillForm.controls[i].updateValueAndValidity();
				return;
			}
		}
		let checkLog = that.checkWaybillForm.controls.checkLog.value;
		let checkLogTips = that.checkWaybillForm.controls.checkLogTips.value;
		if (this.checkLogSwitch == 1) {
			if (checkLog == "" || checkLog == null) {
				super.showMessage(that.messageSub, '请填写其它原因！', 'error');
				return;
			}
		} else {
			if (checkLogTips == 1) {
				that.checkWaybillForm.controls.checkLog.setValue('行驶证照片模糊');
			} else if (checkLogTips == 2) {
				that.checkWaybillForm.controls.checkLog.setValue('道路运输证照片模糊');
			} else if (checkLogTips == 3) {
				that.checkWaybillForm.controls.checkLog.setValue('行驶证不符');
			} else if (checkLogTips == 5) {
				that.checkWaybillForm.controls.checkLog.setValue('道路运输证不符');
			}
		}
		const options = {
			id: that.tempId,
			token: this.formToken,
			formId: this.formId,
			checkLog: that.checkWaybillForm.controls.checkLog.value
		};
		that.httpHelp.loadingBlock = true;
		that.httpHelp.post('psg/trucks/noCheck-trucks',
			options
		).then(res => {
			that.httpHelp.loadingBlock = false;
			if (res['status'] == that.svrType) {
				that.noCheckWaybillDialogFlag = false;
				that.showTruckCheckFlag = false;
				that.showMessage(that.messageSub, res['message']);
				that.queryList();
			} else {
				that.showMessage(that.messageSub, res['message'], 'error');
			}
		});
	}

	// 审核车辆
	checkTruck() {
		this.checksTruckForm.patchValue({
			checkFlag: 2,
			checkLog: '',
		});
		this.currentDriverCheckFlag = 2;
		this.checksTruckDialog = true;
	}

	currentDriverCheckFlag = 2;

	// 切换审核状态
	changeCheckStatus(status) {
		this.currentDriverCheckFlag = status;
	}

	saveCheckTruck() {
		let flag = false;
		let ids = '';
		this.selectedItem.forEach(item => {
			ids += item.id + ',';
			if (item.checkFlag != 1) {
				flag = true;
			}
		});
		if (flag) {
			this.showMessage(this.messageSub, '选中数据已审核结束，不能重复审核', 'error');
			return;
		}
		this.httpHelp.save({
			confirm: this.configSrv,
			url: 'psg/trucks/checks-truck',
			options: {
				ids: ids
			},
			validateForm: this.checksTruckForm,
			success: (res => {
				this.httpHelp.loadingBlock = false;
				if (res['status'] == this.svrType) {
					this.checksTruckDialog = false;
					this.queryList();
				} else {
					this.showMessage(this.messageSub, res['message'], 'error');
				}
			})
		});
	}

	// 删除数据
	delete() : void {
		let ids = '';
		const that = this;
		that.selectedItem.forEach(item => {
			ids += item.id + ',';
		});
		that.httpHelp.delete({
			url: 'psg/trucks/delete-trucks',
			deleteId: ids,
			confirm: that.configSrv,
			success: (res) => {
				this.httpHelp.loadingBlock = false;
				if (res['status'] == 'success') {
					that.showMessage(that.messageSub, res['message']);
					that.queryList();
				} else {
					that.showMessage(that.messageSub, res['message'], 'error');
				}
			}
		});
	}
	//查看图片
	priviewImgs(urls) {
		let files = [];
		//通过该种方式直接预览本地上传文件
		if (urls.changingThisBreaksApplicationSecurity == undefined) {
			files.push(urls);
		} else {
			files.push(urls.changingThisBreaksApplicationSecurity);
		}
		this.imagePreviewService.preview(files);
	}

	//查询关联车主
	dialogSubTitle = '';
	queryRelTeam(data ?) {
		let truckId = '';
		if (data) {
			truckId = data.id;
			this.tempId = data.id;
			this.dialogSubTitle = data.plateNumber;
		} else {
			truckId = this.tempId;
		}
		//加载司机列表
		this.httpHelp.loadingBlock = true;
		this.httpHelp.get('psg/trucks/get-truck-rel-detail', {
			truckId: truckId,
		}).then(res => {
			this.httpHelp.loadingBlock = false;
			if (res['status'] === this.svrType) {
				if (res['data']) {
					this.relTeam.relTeamList = res['data']['relTeamList'];

					this.relDriver.relDriverList = res['data']['relDriverList'];

				}
				this.relDriver['relDriverDialogFlag'] = true;
			} else {
				super.showMessage(this.messageSub, res['message'], 'error');
			}
		});
	}
	//添加车主关联
	addTeamTruck() {
		//this.httpHelp.loadingBlock = true;
		// this.httpHelp.get('psg/team/page-rel-team-truck', {
		// }).then(res => {
		//   this.httpHelp.loadingBlock = false;
		//   if (res['status'] === this.svrType) {
		//     if (res['data']) {
		//       this.relTeam.relTeamList = res['data'];
		//     }
		//     this.relTeam.relTeamDialogFlag = true;
		//   } else {
		//     super.showMessage(this.messageSub, res['message'], 'error');
		//   }
		// });

		this.validateTramTruckForm.reset();
		this.relTeam['addRelTeamDialogFlag'] = true;

	}

	//添加司机关联
	addDriverTruck() {
		this.uploadFileUrl.drivingLicensePhotoUrl = 'assets/file/image/business-photo.png';
		this.uploadFileUrl.idCardFrontUrl = 'assets/file/image/id-card-front.png';
		this.uploadFileUrl.idCardBackUrl = 'assets/file/image/id-card-back.png';
		// this.tempId = null;
		this.validateDriverTruckForm.reset();
		this.validateFormPhone.reset();
		this.editDialogType = 1;
		this.id_card_no_front_url = 'assets/file/image/sfzFront.png';
		this.editDriverIdCardDialogFlag = true;
	}


	//
	checkTeamTruck() {

	}
	//
	delTeamTruck() {

	}

	delDriverTruck() {
		let ids = '';
		const that = this;
		that.relDriver['selectedrelDriverList'].forEach(item => {
			ids += item.id + ',';
		});
		this.httpHelp.delete({
			confirm: this.configSrv,
			url: 'psg/drivers/delete-rel-drivers-truck',
			deleteId: ids,
			success: (res) => {
				this.httpHelp.loadingBlock = false;
				if (res['status'] == this.svrType) {
					that.commonGetDriverList();
				} else {
					super.showMessage(this.messageSub, res['message'], 'error');
				}
			}
		});
	}

	//上传车主与车辆协议
	uploadTeamTruckPhoto(res) {

	}
	//查看车主与车辆协议
	checkTeamTruckPhoto(res) {

	}



	/*========================车主审核开始================================ */
	showTruckCheckFlag = false;
	localTruckDetail = {};
	imgPriview;                                                               // 展示图
	thumbnailImageSrc = [];                                                       // 缩略图
	current = 0;                                                                  // 旋转角度
	imgDescribe = '';
	vehicleLicensePhoto = '';
	optCertPhoto = '';
	relDriverList = [];
	relTeamList = [];
	relAgentList = [];
	relCusList = [];
	checkList = [];
	//打开审核弹框
	checkDriverFlag(event) {
		this.localTruckDetail['id'] = event['id'];
		this.showTruckCheckFlag = true;

		// this.tempId = null;
		// this.thumbnailImageSrc = [];
		// this.imgDescribe = '';
		// this.vehicleLicensePhoto = '';
		// this.optCertPhoto = '';
		// this.relDriverList = [];
		// this.relTeamList = [];
		// this.relAgentList = [];
		// this.relCusList = [];
		// this.checkList = [];
		// this.httpHelp.loadingBlock = true;
		// this.httpHelp.get('psg/trucks/get-plateNumber-list', { truckId: event['id'] }).then(res => {
		//   this.httpHelp.loadingBlock = false;
		//   if (res['status'] == this.svrType) {
		//     if (res['data']) {
		//       //参数数据
		//       this.localTruckDetail = res['data'];
		//       this.localTruckDetail['expiredWarnDay'] = event['expiredWarnDay'];
		//       this.tempId = this.localTruckDetail['id'];
		//       // 行驶证
		//       if (this.localTruckDetail['vehicleLicensePhoto']) {
		//         this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, this.localTruckDetail['vehicleLicensePhoto']).then(res1 => {
		//           if (res['status'] == this.svrType) {
		//             this.vehicleLicensePhoto = res1['data']['url'];
		//             let obj = { 'url': this.vehicleLicensePhoto, 'title': '行驶证' };
		//             this.thumbnailImageSrc.push(obj);
		//             if (this.thumbnailImageSrc.length > 0) {
		//               this.imgDescribe = this.thumbnailImageSrc[0]['title'];
		//             }
		//           }
		//         })
		//       }
		//       //道路运输证
		//       if (this.localTruckDetail['optCertPhoto']) {
		//         this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, this.localTruckDetail['optCertPhoto']).then(res2 => {
		//           if (res['status'] == this.svrType) {
		//             this.optCertPhoto = res2['data']['url']
		//             let obj = { 'url': this.optCertPhoto, 'title': '道路运输证' };
		//             this.thumbnailImageSrc.push(obj);
		//             if (this.thumbnailImageSrc.length > 0) {
		//               this.imgDescribe = this.thumbnailImageSrc[0]['title'];
		//             }
		//           }
		//         })
		//       }
		//     }
		//     //加载审核日志
		//     this.httpHelp.get('psg/operateLog/get-check-log-list', { objId: event['id'], objType: 10 }).then(res2 => {
		//       if (res2['status'] == this.svrType) {
		//         this.checkList = [{
		//           remark: '',
		//           status: 1,
		//           createTime: this.localTruckDetail['createTime'],
		//           creatorName: this.localTruckDetail['creatorName']
		//         }];
		//         let data = res2['data'];
		//         if (data) {
		//           data.forEach(item => {
		//             this.checkList.push({
		//               status: item.status,
		//               createTime: item.createTime,
		//               creatorName: item.creatorName,
		//               remark: item.remark
		//             });
		//           });
		//         }
		//       } else {
		//         this.showMessage(this.messageSub, '加载审核日志异常：' + res2['message'], 'error');
		//       }
		//     });
		//     this.showTruckCheckFlag = true;
		//   } else {
		//     this.showMessage(this.messageSub, '加载基础数据异常：' + res['message'], 'error');
		//   }
		// });
		//加载关联数据
		// this.httpHelp.get('psg/trucks/get-truck-rel-detail', { truckId: event['id'] }).then(res => {
		//   if (res['status'] == this.svrType) {
		//     if (res['data']) {
		//       this.relDriverList = res['data']['relDriverList'];
		//       this.relTeamList = res['data']['relTeamList'];
		//       //加载代理商
		//       if (res['data']['relAgentList'].length > 0) {
		//         let agentIds = '';
		//         let relAgentListTmp = res['data']['relAgentList'];
		//         relAgentListTmp.forEach(item => {
		//           agentIds += item.agentId + ',';
		//         });
		//         this.httpHelp.get('sys/agent/query-rel-agent', { ids: agentIds }).then(res => {
		//           if (res['status'] == 'success') {
		//             this.relAgentList = res['data'];//关联代理商信息
		//           } else {
		//           }
		//         });
		//       }
		//       //关联托运方信息
		//       if (res['data']['relCusList'].length > 0) {
		//         let custIds = '';
		//         let relCusListTmp = res['data']['relCusList'];
		//         relCusListTmp.forEach(item => {
		//           custIds += item.shipperId + ',';
		//         });
		//         //加载托运方
		//         this.httpHelp.get('sys/cust/query-rel-cust', { ids: custIds }).then(res => {
		//           if (res['status'] == 'success') {
		//             this.relCusList = res['data'];
		//           } else {
		//           }
		//         });
		//       }
		//     }
		//   } else {
		//     this.showMessage(this.messageSub, '加载基础数据异常：' + res['message'], 'error');
		//   }
		// });

	}
	// 预览右侧缩略图
	previewThumbnailImage() {
		var img = document.querySelector('.img-preview-img').getAttribute("src")
		let show_photo_list = [];
		let index = 0;
		for (var i = 0; i < this.thumbnailImageSrc.length; i++) {
			let e = this.thumbnailImageSrc[i];
			if (e['url'] == img) {
				index = i;
			}
			show_photo_list.push(e['url']);
		}
		this.imagePreviewService.preview(show_photo_list, index);
	}
	// 向左旋转
	handleTurnLeft() {
		let img = <HTMLImageElement>document.querySelector('.img-preview')
		this.current = (this.current - 90) % 360;
		img.style.transform = 'rotate(' + this.current + 'deg)'
	}
	// 向右旋转
	handleTurnright() {
		let img = <HTMLImageElement>document.querySelector('.img-preview')
		this.current = (this.current + 90) % 360;
		img.style.transform = 'rotate(' + this.current + 'deg)'
	}
	// 预览图切换
	previewImgIndex = 0                                                                           // 小图下标
	afiles = [];
	handlePreviewImgClick(item, i) {
		this.imgPriview = item.url;
		this.imgDescribe = item.title;
		this.previewImgIndex = i;
		this.current = 0
		this.afiles.push(this.imgPriview)
	}
	/*========================车主审核结束================================ */

	// 查看司机人车照
	checkDriverTruckPhoto(data) {
		if (!data || !data['driverTruckPhoto']) {
			this.showMessage(this.messageSub, '未找到人车照片信息', 'error');
			return;
		}
		
		this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, data['driverTruckPhoto'], 2).then(res => {
			if (res['status'] == this.svrType) {
				if (res['data'] && res['data']['url']) {
					this.imagePreviewService.preview([
						res['data']['url']
					]);
				} else {
					this.showMessage(this.messageSub, '获取照片失败：未找到图片地址', 'error');
				}
			} else {
				this.showMessage(this.messageSub, '获取照片失败：' + res['message'], 'error');
			}
		}).catch(err => {
			console.error('查看人车照失败:', err);
			this.showMessage(this.messageSub, '查看人车照失败', 'error');
		});
	}


	// 上传司机人车照
	uploadDri(data) {
		this.myTruck['truckDetailHeader'] = data.plateNumber;
		this.tempId = data.truckId;
		this.myTruck['tempTruckId'] = data.driverId;
		this.myTruck['driver_truck_photo_url'] = 'assets/file/image/driverTruckPhoto.png';
		this.myTruck['driverTruckPhotoFlag'] = true;
	}


	//保存上传人车照片数据
	async saveUploadDriverTruckPhoto() {

		// 上传文件
		let driver_truck_photo_url = '';        // 人车照
		if (this.editUploadFiles.driver_truck_photo != '') {
			await this.ossFileService.uploadOSSFile(this.editUploadFiles.driver_truck_photo, this.regExUtils.TRUCK).
				then(res => {
					if (res['status'] == this.svrType) {
						driver_truck_photo_url = res['uploadName'];
					} else {
						that.httpHelp.loadingBlock = false;
						that.showMessage(this.messageSub, res['message'], 'error');
					}
				});
		}
		const that = this;
		const options = {
			driverId: that.myTruck.tempTruckId,
			truckId: that.tempId
		};
		if (driver_truck_photo_url != '') {
			options['driverTruckPhoto'] = driver_truck_photo_url;
		}
		this.httpHelp.loadingBlock = true;
		await this.httpHelp.post('psg/drivers/save-driver-truck-photo', options).then(res => {
			this.httpHelp.loadingBlock = false;
			if (res['status'] === this.svrType) {
				// that.commonGetDriverList();
				this.queryRelTeam();
				this.myTruck['truckCheckDialogFlag'] = false;
				this.myTruck['driverTruckPhotoFlag'] = false;
				this.showMessage(this.messageSub, res['message']);
			} else {
				super.showMessage(this.messageSub, res['message'], 'error');
			}
		}).catch(err => { });
	}


	//查看车主协议
	checkTeamAgreePhoto(data) {
		this.ossFileService.viewOSSFile(this.regExUtils.TEAM, data['agreementPhoto']).then(res => {
			if (res['status'] == this.svrType) {
				this.imagePreviewService.preview([
					res['data']['url']
				]);
			} else {
				this.showMessage(this.messageSub, res['message'], 'error');
			}
		});
	}

	// 选择挂靠协议照片
	onSelectDepartPhoto(event) {
		const fileList : [] = event.currentFiles;
		fileList.forEach((e, i) => {
			if (this.departUploadFileList.length < 5) {
				this.departUploadFileList.push(e);
				this.uploadImg.push({
					img_url: e['objectURL']['changingThisBreaksApplicationSecurity']
				})
			}
		});
		this.clearDepartFileUpload.nativeElement.click();
	}

	//查看图片
	priviewImgss(urls, i) {
		let files = [];
		//通过该种方式直接预览本地上传文件
		//if (urls.changingThisBreaksApplicationSecurity == undefined) {
		urls.forEach(e => {
			files.push(e.img_url);
		});

		//} else {
		//files.push(urls.changingThisBreaksApplicationSecurity);
		//}
		this.imagePreviewService.preview(files, i);
	}

	// 删除车主挂靠协议照片
	deleteDepartFile(i) {
		delete this.departUploadFileList[i];
		this.departUploadFileList = this.departUploadFileList.filter(e => e);
		this.uploadImg.splice(i, 1);
	}


	// ===========================车辆司机===========================

	// 车辆司机
	myDriverRes(data) {
		this.tempId = data['id'];
		this.dialogSubTitle = data['plateNumber'];
		this.commonGetDriverList();
	}

	commonGetDriverList() {
		const that = this;
		this.httpHelp.loadingBlock = true;
		this.httpHelp.get('psg/trucks/get-truck-rel-detail', { truckId: that.tempId }).then(res => {
			this.httpHelp.loadingBlock = false;
			if (res['status'] === this.svrType) {
				that.relDriver['relDriverList'] = res['data']['relDriverList'];
				that.relDriver['selectedrelDriverList'] = [];
				this.relDriver['relDriverDialogFlag'] = true;

			} else {
				this.showMessage(this.messageSub, res['message'], 'error');
			}
		});
	}




	//验证司机身份证信息
	async identifyCard(event) {
		this.identifyIdCardFrontUrl = event['files'][0]['objectURL']['changingThisBreaksApplicationSecurity'];
		let result = {};
		// 上传司机证件
		this.httpHelp.loadingBlock = true;
		await this.ossFileService.uploadOSSFile(event['currentFiles'][0], this.regExUtils.ID_CARD).then(res => {
			if (res['status'] == this.svrType) {
				result = res;
			} else {
				this.httpHelp.loadingBlock = false;
			}
		});
		this.httpHelp.get('psg/common/analysis-img', {
			folder: this.regExUtils.ID_CARD,
			imgName: result['uploadName'],
			fileType: 'id_card_front'
		}).then(res => {
			this.httpHelp.loadingBlock = false;
			if (res['status'] == this.svrType) {
				let idCardNo = res['data']['analysisData']['card'];
				let birthDate = '';
				let sex = 1;
				if (idCardNo != null && idCardNo != "") {
					if (idCardNo.length == 15) {
						birthDate = "19" + idCardNo.substr(6, 6);
					} else if (idCardNo.length == 18) {
						birthDate = idCardNo.substr(6, 8);
					}
					birthDate = birthDate.replace(/(.{4})(.{2})/, "$1-$2-");
					if (parseInt(idCardNo.substr(16, 1)) % 2 == 1) {
						sex = 1;
					} else {
						sex = 0;
					}
				}
				this.validateFormPhone.patchValue({
					idCardNo: res['data']['analysisData']['card'],
					address: res['data']['analysisData']['addr'],
					realname: res['data']['analysisData']['name'],
					sex: sex,
					birthDate: birthDate,
					idCardImgName: result['uploadName']
				});
			} else {
				this.showMessage(this.messageSub, res['message'], 'error');
			}
		});
	}

	// 选择身份证，并识别
	async onSelectIdcard(event) {
		this.idCardFrontUrl = this.sanitizer.bypassSecurityTrustUrl(event['files'][0]['objectURL']['changingThisBreaksApplicationSecurity']);
		let result = {};
		// 上传司机证件
		this.httpHelp.loadingBlock = true;
		await this.ossFileService.uploadOSSFile(event['currentFiles'][0], this.regExUtils.ID_CARD).then(res => {
			if (res['status'] == this.svrType) {
				result = res;
			} else {
				this.httpHelp.loadingBlock = false;
			}
		});
		this.idCardFrontInput.nativeElement.click();
		this.httpHelp.get('psg/common/analysis-img', {
			folder: this.regExUtils.ID_CARD,
			imgName: result['uploadName'],
			fileType: 'id_card_front'
		}).then(res => {
			this.httpHelp.loadingBlock = false;
			if (res['status'] == this.svrType) {
				let idCardNo = res['data']['analysisData']['card'];
				let birthDate = '';
				let sex = 1;
				if (idCardNo != null && idCardNo != "") {
					if (idCardNo.length == 15) {
						birthDate = "19" + idCardNo.substr(6, 6);
					} else if (idCardNo.length == 18) {
						birthDate = idCardNo.substr(6, 8);
					}
					birthDate = birthDate.replace(/(.{4})(.{2})/, "$1-$2-");
					if (parseInt(idCardNo.substr(16, 1)) % 2 == 1) {
						sex = 1;
					} else {
						sex = 0;
					}
				}
				this.validateDriverTruckForm.patchValue({
					idCardNo: res['data']['analysisData']['card'],
					address: res['data']['analysisData']['addr'],
					realname: res['data']['analysisData']['name'],
					sex: sex,
					birthDate: birthDate,
					idCardNoFront: result['uploadName']
				});
			} else {
				this.showMessage(this.messageSub, res['message'], 'error');
			}
		});
		this.editUploadFiles.id_card_no_front = this.idCardFrontUrl;
	}

	// 选择身份证背面
	async onSelectIdCardBack(event) {
		this.idCardBackUrl = this.sanitizer.bypassSecurityTrustUrl(event['files'][0]['objectURL']['changingThisBreaksApplicationSecurity']);;
		let result = {};
		// 上传司机证件
		this.httpHelp.loadingBlock = true;
		await this.ossFileService.uploadOSSFile(event['currentFiles'][0], this.regExUtils.ID_CARD).then(res => {
			if (res['status'] == this.svrType) {
				result = res;
			} else {
				this.httpHelp.loadingBlock = false;
			}
		});
		this.idCardBackInput.nativeElement.click();
		this.httpHelp.get('psg/common/analysis-img', {
			folder: this.regExUtils.ID_CARD,
			imgName: result['uploadName'],
			fileType: 'id_card_back'
		}).then(res => {
			this.httpHelp.loadingBlock = false;
			if (res['status'] == this.svrType) {
				let signDate = res['data']['analysisData']['signDate'];
				if (signDate.length == 8 && signDate != undefined) {
					signDate = signDate.substring(0, 4) + '-' + signDate.substring(4, 6) + '-' + signDate.substring(6, 8);
				} else {
					signDate = '';
				}
				let expire = res['data']['analysisData']['expire'];
				if (expire.length == 8 && expire != undefined) {
					expire = expire.substring(0, 4) + '-' + expire.substring(4, 6) + '-' + expire.substring(6, 8);
				} else {
					if (expire == '长期') {
						expire = '9999-12-31';
					} else {
						expire = '';
					}
				}
				this.validateDriverTruckForm.patchValue({
					startUseDate: signDate,
					endUseDate: expire,
					idCardNoBack: result['uploadName']
				});
			} else {
				this.showMessage(this.messageSub, res['message'] + '请检查照片是否清晰！', 'error');
			}
		});
		this.editUploadFiles.id_card_no_back = this.idCardBackUrl;
	}



	//驾驶证
	async onSelectBusiness(event) {
		this.drivingLicensePhotoUrl = this.sanitizer.bypassSecurityTrustUrl(event['files'][0]['objectURL']['changingThisBreaksApplicationSecurity']);
		this.httpHelp.loadingBlock = true;
		let result = {};
		await this.ossFileService.uploadOSSFile(event['currentFiles'][0], this.regExUtils.ID_CARD).then(res => {
			if (res['status'] == this.svrType) {
				result = res;
			} else {
				this.httpHelp.loadingBlock = false;
			}
		});
		this.drivingLicensePhotoInput.nativeElement.click();
		this.httpHelp.get('psg/common/analysis-img', {
			folder: this.regExUtils.ID_CARD,
			imgName: result['uploadName'],
			fileType: 'driving_licence'
		}).then(res => {
			this.httpHelp.loadingBlock = false;
			if (res['status'] == this.svrType) {
				let validateDate = '';//驾驶证有效期起
				let expire = '';//驾驶证有效期止
				let signGroup = '';//发证机关
				let driveType = this.driverTypeList[0]['value'];//准驾车型
				let num = '';//驾驶证号
				if (res['data'] != null && res['data'] != "") {
					num = res['data']['analysisData']['num'];
					let idCardNo = this.validateDriverTruckForm.controls.idCardNo.value;
					if (idCardNo == '' || idCardNo == null) {
						this.showMessage(this.messageSub, '请先上传身份证照片！', 'error');
						return;
					} else {
						if (idCardNo != num) {
							this.showMessage(this.messageSub, '请核实驾驶证是否所属该司机！', 'warn');
						}
					}
					validateDate = res['data']['analysisData']['validateDate'];
					if (validateDate.length == 8 && validateDate != undefined) {
						validateDate = validateDate.replace(/(.{4})(.{2})/, "$1-$2-");
					} else {
						validateDate = '';
					}
					expire = res['data']['analysisData']['expire'];
					if (expire.indexOf('年') > 0) {
						try {
							let tmpExpire = expire.replace("年", "");
							if (validateDate) {
								let date = new Date(validateDate);
								let year = date.getFullYear() + parseInt(tmpExpire);
								let month = date.getMonth();
								let day = date.getDate();
								expire = year + "-" +
									((month + 1) > 9 ? (month + 1) : "0" + (month + 1)) + "-" +
									(day > 9 ? day : ("0" + day));
							}
						} catch (e) {
							expire = '';
						}
					} else {
						if (expire.length == 8 && expire != undefined) {
							expire = expire.replace(/(.{4})(.{2})/, "$1-$2-");
						} else {
							if (expire == '长期') {
								expire = '9999-12-31';
							} else {
								expire = '';
							}
						}
					}
					signGroup = res['data']['analysisData']['signGroup'];
					driveType = res['data']['analysisData']['driveType'];
					if (driveType == '' || driveType == null) {
						driveType = this.driverTypeList[0]['value'];
					}
				} else {
					this.showMessage(this.messageSub, '未识别到驾驶证信息，请检查照片是否清晰！', 'error');
					return;
				}
				this.validateDriverTruckForm.patchValue({
					driverType: driveType,
					drivingStartUseDate: validateDate,
					drivingEndUseDate: expire,
					issuingOrganizations: signGroup,
					drivingLicensePhoto: result['uploadName']
				});
			} else {
				this.showMessage(this.messageSub, res['message'] + '请检查照片是否清晰！', 'error');
			}
		});
		this.editUploadFiles.driving_license_photo = this.drivingLicensePhotoUrl;
	}


	//上传司机从业资格证
	async onSelectQualificationCert(event) {
		this.qualificationCertPhotoUrl = this.sanitizer.bypassSecurityTrustUrl(event['files'][0]['objectURL']['changingThisBreaksApplicationSecurity']);
		this.httpHelp.loadingBlock = true;
		let result = {};
		await this.ossFileService.uploadOSSFile(event['currentFiles'][0], this.regExUtils.ID_CARD).then(res => {
			if (res['status'] == this.svrType) {
				result = res;
			} else {
				this.httpHelp.loadingBlock = false;
			}
		});
		this.qualificationCertPhotoInput.nativeElement.click();
		this.httpHelp.loadingBlock = false;
		this.validateDriverTruckForm.patchValue({
			qualificationCertPhoto: result['uploadName']
		});
		this.editUploadFiles.qualification_cert_photo = this.qualificationCertPhotoUrl;
	}



	// 身份证自动上传识别
	onIdCardUpload(event) {
		this.httpHelp.loadingBlock = false;
		if (event.originalEvent['body']) {
			const res = event.originalEvent['body'];
			if (res.status == this.svrType) {
				this.tempId = res['data'].id;
				this.validateFormPhone.patchValue({
					idCardNo: res['data'].idCardNo
				});
			} else {
				this.showMessage(this.messageSub, res.message, 'error');
			}
		}
	}


	// 查询司机是否存在
	queryDriver() {
		if (this.validateFormPhone.get('idCardNo').value == null) {
			this.showMessage(this.MessageSub, '请上传身份证正面或者填写身份证号', 'error');
			return;
		}
		let idCardNo = ''
		if (this.validateFormPhone.get('idCardNo').value != null) {
			idCardNo = this.validateFormPhone.get('idCardNo').value.replaceAll(" ", "")
		}
		this.editUploadFiles.id_card_no_front = 'assets/file/image/sfzFront.png';
		this.editUploadFiles.id_card_no_back = 'assets/file/image/sfzBack.png';
		this.editUploadFiles.driving_license_photo = 'assets/file/image/driverLicense.png';
		this.editUploadFiles.qualification_cert_photo = 'assets/file/image/driverLicense.png';
		this.httpHelp.loadingBlock = true;
		this.httpHelp.get('psg/drivers/get-card-list', {
			//driverId: this.tempId,
			idCardNo: idCardNo
		}).then(res => {
			this.httpHelp.loadingBlock = false;
			this.validateDriverTruckForm.reset();
			if (res['status'] === this.svrType) {
				this.editDialogFlag = true;
				this.idCardFrontUrl = 'assets/file/image/id-card-front.png';
				this.idCardBackUrl = 'assets/file/image/id-card-back.png';
				this.drivingLicensePhotoUrl = 'assets/file/image/xsz.png';
				this.qualificationCertPhotoUrl = 'assets/file/image/xsz.png';
				if (res['data']) {
					// 处理重复司机数据
					const driverItem = res['data'];
					if (driverItem['birthDate']) {
						driverItem['birthDate'] = this.setCreateTime(driverItem['birthDate'] * 1000, 'yyyy-MM-dd');
					}
					if (driverItem['startUseDate']) {
						driverItem['startUseDate'] = this.setCreateTime(driverItem['startUseDate'] * 1000, 'yyyy-MM-dd');
					}
					if (driverItem['endUseDate']) {
						driverItem['endUseDate'] = this.setCreateTime(driverItem['endUseDate'] * 1000, 'yyyy-MM-dd');
					}
					if (driverItem['drivingStartUseDate']) {
						driverItem['drivingStartUseDate'] = this.setCreateTime(driverItem['drivingStartUseDate'] * 1000, 'yyyy-MM-dd');
					}
					if (driverItem['drivingEndUseDate']) {
						driverItem['drivingEndUseDate'] = this.setCreateTime(driverItem['drivingEndUseDate'] * 1000, 'yyyy-MM-dd');
					}
					if (driverItem['qualificationCertExpireTime']) {
						driverItem['qualificationCertExpireTime'] = this.setCreateTime(driverItem['qualificationCertExpireTime'] * 1000, 'yyyy-MM-dd');
					}
					this.validateDriverTruckForm.patchValue(driverItem);
					this.validateDriverTruckForm.patchValue({
						politicalOutlook: this.politicalOutlookLists.length > 0 ? this.politicalOutlookLists[0]['value'] : '',
						driverType: this.driverTypeList.length > 0 ? this.driverTypeList[0]['value'] : ''
					});
					// 查询预览图片
					if (driverItem.idCardNoFront) {
						this.ossFileService.viewOSSFile(this.regExUtils.ID_CARD, driverItem.idCardNoFront).then(res => {
							if (res['status'] == this.svrType) {
								this.idCardFrontUrl = res['data']['url'];
							}
						});
					}
					if (driverItem.idCardNoBack) {
						this.ossFileService.viewOSSFile(this.regExUtils.ID_CARD, driverItem.idCardNoBack).then(res => {
							if (res['status'] == this.svrType) {
								this.idCardBackUrl = res['data']['url'];
							}
						});
					}
					if (driverItem.drivingLicensePhoto) {
						this.ossFileService.viewOSSFile(this.regExUtils.ID_CARD, driverItem.drivingLicensePhoto).then(res => {
							if (res['status'] == this.svrType) {
								this.drivingLicensePhotoUrl = res['data']['url'];
							}
						});
					}
					if (driverItem.qualificationCertPhoto) {
						this.ossFileService.viewOSSFile(this.regExUtils.ID_CARD, driverItem.qualificationCertPhoto).then(res => {
							if (res['status'] == this.svrType) {
								this.qualificationCertPhotoUrl = res['data']['url'];
							}
						});
					}
				} else {    // 无司机数据
					if (this.identifyIdCardFrontUrl != 'assets/file/image/sfzFront.png') {
						const driverItem = {
							realname: this.validateFormPhone.get('realname').value,
							idCardNo: this.validateFormPhone.get('idCardNo').value,
							address: this.validateFormPhone.get('address').value,
							sex: this.validateFormPhone.get('sex').value,
							birthDate: this.validateFormPhone.get('birthDate').value,
							idCardNoFront: this.validateFormPhone.get('idCardImgName').value,
							politicalOutlook: this.politicalOutlookLists.length > 0 ? this.politicalOutlookLists[0]['value'] + '' : '',
							driverType: this.driverTypeList.length > 0 ? this.driverTypeList[0]['value'] + '' : '',
						};
						// 获取司机证件预览图片
						this.ossFileService.viewOSSFile(this.regExUtils.ID_CARD, this.validateFormPhone.get('idCardImgName').value).then(res => {
							if (res['status'] == this.svrType) {
								this.idCardFrontUrl = res['data']['url'];
							} else {
								this.showMessage(this.MessageSub, res['message'], 'error');
							}
						});
						this.validateDriverTruckForm.patchValue(driverItem);
					} else {
						const driverItem = {
							idCardNo: this.validateFormPhone.get('idCardNo').value,
						};
						this.validateDriverTruckForm.patchValue(driverItem);
					}
				}
			} else {
				super.showMessage(this.MessageSub, res['message'], 'error');
			}
		});
	};
	// 保存编辑
	saveDriver() {
		if (this.idCardBackUrl == 'assets/file/image/id-card-back.png') {
			this.showMessage(this.messageSub, '请上传身份证国徽面照片', 'error');
			return;
		}
		if (this.idCardFrontUrl == 'assets/file/image/id-card-back.png') {
			this.showMessage(this.messageSub, '请上传身份证背面照片', 'error');
			return;
		}
		if (this.drivingLicensePhotoUrl == 'assets/file/image/business-photo.png') {
			this.showMessage(this.messageSub, '请上传驾驶证照片', 'error');
			return;
		}

		for (const i in this.validateDriverTruckForm.controls) {
			if (this.validateDriverTruckForm.controls[i].invalid) {
				this.validateDriverTruckForm.controls[i].markAsDirty();
				this.validateDriverTruckForm.controls[i].updateValueAndValidity();
				return;
			}
		}
		// 验证表单
		let mobilePhone = this.validateDriverTruckForm.controls.mobilePhone.value;
		if (mobilePhone != '' || mobilePhone != null) {
			mobilePhone = mobilePhone.replaceAll(" ", "");
		}
		if (!(this.regExUtils.PHONE_NUMBER_RULE.test(mobilePhone))) {
			this.showMessage(this.messageSub, '手机号码有误，请重填', 'error');
			return;
		}
		let idCardNo = this.validateDriverTruckForm.controls.idCardNo.value;
		if (idCardNo != '' || idCardNo != null) {
			idCardNo = idCardNo.replaceAll(" ", "");
		}
		if (!(this.regExUtils.ID_CARD_NO_RULE.test(idCardNo))) {
			this.showMessage(this.messageSub, '身份证号有误，请重填', 'error');
			return;
		}
		this.configSrv.confirm({
			message: '确定保存司机信息吗',
			icon: 'pi pi-exclamation-triangle',
			header: '保存确认',
			acceptLabel: '确定',
			rejectLabel: '取消',
			rejectButtonStyleClass: 'p-button-raised p-button-text p-button-plain',
			accept: () => {
				this.httpHelp.loadingBlock = true;
				this.saveDriverInfo();
			},
			reject: () => {

			},
			key: 'confirm'
		});
	}

	getPlateNumber(data ?) {
		if (data.filter == null) {
			this.searchForm.patchValue({
				id: null
			})
		}
		let plateNumber1 = ''
		if (data) {
			plateNumber1 = data.filter
		}
		this.httpHelp.get('psg/trucks/get-plateNumber', { plateNumber: plateNumber1 }).then(res => {
			if (res['status'] == 'success') {
				this.plateNumberMap = {};
				this.plateNumberList = [];
				const tempShipperIdList = res['data']['plateNumbers'];
				tempShipperIdList.forEach(e => {
					this.plateNumberMap[e['id']] = e['plateNumber'];
					// this.plateNumberList.push({
					//   label: e['plateNumber'],
					//   value: e['id']
					// });
				});
				this.plateNumberList = this.getLocalDropdown(this.plateNumberMap, true);
				// console.log(this.plateNumberList)
			} else {
				// this.showMessage()
			}
		});
	}

	getTeamId(data ?) {
		if (data.filter == null) {
			this.searchForm.patchValue({
				teamId: null
			})
		}
		let realname = ''
		if (data) {
			realname = data.filter
		}
		this.httpHelp.get('psg/team/get-teamById', { realname: realname }).then(res => {
			if (res['status'] == 'success') {
				this.teamIdMap = {};
				this.teamList = [];
				const tempShipperIdList = res['data']['teams'];
				tempShipperIdList.forEach(e => {
					this.teamIdMap[e['id']] = e['realname'];
					// this.plateNumberList.push({
					//   label: e['plateNumber'],
					//   value: e['id']
					// });
				});
				this.teamList = this.getLocalDropdown(this.teamIdMap, true);
				// console.log(this.plateNumberList)
			} else {
				// this.showMessage()
			}
		});
	}

	getTeamId1() {
		this.httpHelp.get('psg/team/get-teamById', {}).then(res => {
			if (res['status'] == 'success') {
				this.teamIdMap = {};
				this.teamList = [];
				const tempShipperIdList = res['data']['teams'];
				tempShipperIdList.forEach(e => {
					this.teamIdMap[e['id']] = e['realname'];
					// this.plateNumberList.push({
					//   label: e['plateNumber'],
					//   value: e['id']
					// });
				});
				this.teamList = this.getLocalDropdown(this.teamIdMap, true);
				// console.log(this.plateNumberList)
			} else {
				// this.showMessage()
			}
		});
	}

	getPlateNumber1() {
		this.httpHelp.get('psg/trucks/get-plateNumber', {}).then(res => {
			if (res['status'] == 'success') {
				this.plateNumberMap = {};
				this.plateNumberList = [];
				const tempShipperIdList = res['data']['plateNumbers'];
				tempShipperIdList.forEach(e => {
					this.plateNumberMap[e['id']] = e['plateNumber'];
					// this.plateNumberList.push({
					//   label: e['plateNumber'],
					//   value: e['id']
					// });
				});
				this.plateNumberList = this.getLocalDropdown(this.plateNumberMap, true);
			} else {
				// this.showMessage()
			}
		});
	}


	// 保存司机信息
	async saveDriverInfo() {
		const that = this;
		let url = 'add-drivers'
		if (that.tempId) {
			url = 'update-drivers'
		}
		const options = {
			truckId: that.tempId,
			token: this.formToken,
			formId: this.formId,

		};
		for (const i in this.validateDriverTruckForm.controls) {
			if (this.validateDriverTruckForm.controls[i].invalid) {
				this.validateDriverTruckForm.controls[i].markAsDirty();
				this.validateDriverTruckForm.controls[i].updateValueAndValidity();
				return;
			} else {
				options[i] = this.validateDriverTruckForm.get(i).value
			}
		}
		if (options['mobilePhone'] != '' || options['mobilePhone'] != null) {
			options['mobilePhone'] = options['mobilePhone'].replaceAll(" ", "");
		}
		if (options['idCardNo'] != '' || options['idCardNo'] != null) {
			options['idCardNo'] = options['idCardNo'].replaceAll(" ", "");
		}
		await this.httpHelp.post('psg/trucks/add-rel-driver', options,).then(res => {
			this.httpHelp.loadingBlock = false;
			if (res['status'] === this.svrType) {
				// that.queryList();
				this.queryRelTeam();
				that.editDialogFlag = false;
				that.editDriverIdCardDialogFlag = false;
				this.dialogBlock = false
				super.showMessage(this.messageSub, res['message']);
			} else {
				super.showMessage(this.messageSub, res['message'], 'error');
			}
		}).catch(err => {

		});
	}


	//选择人车证照片
	async onSelectDriverTruck(event) {
		this.driverTruckPhotoUrl = this.sanitizer.bypassSecurityTrustUrl(event['files'][0]['objectURL']['changingThisBreaksApplicationSecurity']);
		this.httpHelp.loadingBlock = true;
		let result = {};
		await this.ossFileService.uploadOSSFile(event['currentFiles'][0], this.regExUtils.TRUCK).then(res => {
			if (res['status'] == this.svrType) {
				result = res;
			} else {
				this.httpHelp.loadingBlock = false;
			}
		});
		this.driverTruckInput.nativeElement.click();
		this.httpHelp.loadingBlock = false;
		this.validateTruckForm.patchValue({
			driverTruckPhoto: result['uploadName']
		});
		this.editUploadFiles.driver_truck_photo = this.driverTruckPhotoUrl;
	}

	uploadExcelFile : any = null;    // 上传选择导入文件

	// 选择上传excel
	onSelectImportExcel(event) {
		this.uploadExcelFile = event['currentFiles'][0];
		this.basicfileUpload.nativeElement.click();
	}

	async saveImportExcelFile() {
		// 上传excel文件
		this.httpHelp.loadingBlock = true;
		let result = {};
		await this.ossFileService.uploadOSSFile(this.uploadExcelFile, this.regExUtils.IMPORTEXCEL).then(res => {
			if (res['status'] == this.svrType) {
				result = res;
			} else {
				this.httpHelp.loadingBlock = false;
			}
		});
		
		// 获取车辆来源参数
		const isMemberTruck = this.exportForm.get('isMemberTruck').value;
		
		this.httpHelp.post('psg/trucks/import-data', { 
			excelFileName: result['uploadName'], 
			folder: this.regExUtils.IMPORTEXCEL,
			isMemberTruck: isMemberTruck  // 添加车辆来源参数
		}).then(res => {
			this.httpHelp.loadingBlock = false;
			this.dialogBlock = false
			if (res['status'] == this.svrType) {
				this.queryList();
			} else {
				this.showMessage(this.messageSub, res['message'], 'error');
			}
		});
	}

	// 导出表单
	chooseExcel() {
		this.uploadExcelFile = null;
		this.exportForm.patchValue({
			isMemberTruck: 0  // 重置车辆来源为网货
		});
		this.importDialog = true;
	}

	chooseTemplateExcel() {
		this.httpHelp.loadingBlock = true;
		this.httpHelp.get('psg/common/view-img', { folder: "template", imgName: "truckImport.xls" }).then(res => {
			this.httpHelp.loadingBlock = false;
			if (res['status'] == this.svrType) {
				super.downFile(res['data']['url'], "truckImport.xls");
				// this.exportDialog = false;
			} else {
				this.showMessage(this.messageSub, res['message'], 'error');
			}
		});
	}

	// 导入需要对账的运单数据
	importCheckExcel() {
		if (this.uploadExcelFile == null) {
			this.showMessage(this.messageSub, '请先选择需要导入的文件！', 'error');
			return;
		}

		this.configSrv.confirm({
			message: '确定导入文件数据吗',
			icon: 'pi pi-exclamation-triangle',
			header: '保存确认',
			acceptLabel: '确定',
			rejectLabel: '取消',
			rejectButtonStyleClass: 'p-button-raised p-button-text p-button-plain',
			accept: () => {
				this.httpHelp.loadingBlock = true;
				this.saveImportExcelFile();
				this.importDialog = false;

			},
			reject: () => {

			},
			key: 'confirm'
		});
	}

	batchPlateNumber() {
		this.batchPlateNumberDialog = true;
	}

	//保存批次号
	batchNo() {
		let no = this.batchNoForm.get('batchNo').value;
		//将换行符转换为逗号并去掉尾部逗号
		if (no != null) {
			var reg = /,$/gi;
			var warningPhones = no.replace(/\n/g, ',');
			var warningPhones_str = warningPhones.replace(reg, "");
			let nos = [];
			let ids = '';
			if (warningPhones_str && warningPhones_str.lastIndexOf(",") > 0) {
				nos = warningPhones_str.split(",");
				if (nos.length > 0) {
					nos.forEach(item => {
						if (item != '' && item != null) {
							ids += item + ',';
						}
					})
				}
			} else {
				ids = warningPhones_str
			}
			this.searchForm.patchValue({
				plateNumbers: ids.replace(/\s*/g, "")
			})
		}
		this.dialogBlock = false;
		this.batchPlateNumberDialog = false;
	}

	// 保存锁定车主或者解锁车主
	saveTeamLock() {
		let ids = '';
		this.selectedItem.forEach(item => {
			ids += item.id + ',';
		});
		const that = this;
		this.httpHelp.save({
			confirm: this.configSrv,
			url: 'psg/trucks/save-lock-team',
			options: {
				ids: ids,
				lockTeam: that.lockTeamForm.get('lockTeam').value
			},
			validateForm: this.checksTruckForm,
			success: (res => {
				this.httpHelp.loadingBlock = false;
				if (res['status'] == this.svrType) {
					this.lockTeamDialog = false;
					this.dialogBlock = false;
					this.queryList();
				} else {
					this.showMessage(this.messageSub, res['message'], 'error');
				}
			})
		});
	}

	//初始化
	ngOnInit() : void {
		const that = this;
		super.initCurrentPage(that);

		that.operatePageButtons = that.setOperateButtons((value) => {
			if (value == 4) {
				that.editColumnDialog = true;
			} else if (value == 3) {
				that.changeTableList();
			} else if (value == 2) {
				that.showMessage(that.messageSub, '在线文档暂未开发', 'info');
			} else {
				that.showMessage(that.messageSub, '设置筛选条件暂未开发', 'info');
			}
		});
		this.isMemberTruckItem[0].checkFlag = true
		//车辆信息表单
		this.validateTruckForm = this.fb.group({
			plateNumber: [null, [Validators.required]],
			vehicleType: [null, [Validators.required]],
			loadWeight: [null, [Validators.required]],
			fullLoadWeight: [null, [Validators.required]],
			plateColor: [null, [Validators.required]],
			energyType: [null, [Validators.required]],
			isPersonal: [null, [Validators.required]],
			ownName: [null, [Validators.required]],
			businessCertificate: [null],
			businessCertificateExpireTime: [null],
			optCertNo: [null, [Validators.required]],
			optCertExpireTime: [null],
			vehicleLicensePhoto: [null],
			vehicleLicenseBackPhoto: [null],
			businessCertificatePhoto: [null],
			optCertPhoto: [null],
			vehicleLicenseCheckPhoto: [null],
			trailerPlateNumber: [null],
			trailerPlateColor: [null],
			length: [null],
			width: [null],
			height: [null],
			trailerVolume: [null],
			model: [null],
			ownCarrierId: [null],
			useCharacter: [null],
			truckVin: [null],
			issuingOrganizations: [null],
			registerDate: [null],
			issueDate: [null],
			isOnline: [null],
			remark: [null],
			truckType: [null],
			truckSize: [null],
			teamId: [null],
			vehicleExaminedExpirationDate: [null, [Validators.required]]
		});

		//新增关联表单
		this.validateTramTruckForm = this.fb.group({
			agentId: [null],
			shipperId: [null],
			teamId: [null]
		});

		this.checkWaybillForm = this.fb.group({
			checkLog: [null],
			checkLogTips: [null]
		});

		this.batchNoForm = this.fb.group({
			batchNo: [null, [Validators.required]],
		});

		//司机编辑表单初始化
		this.validateDriverTruckForm = this.fb.group({
			realname: [null, [Validators.required]],
			mobilePhone: [null, [Validators.required]],
			politicalOutlook: [null, [Validators.required]],
			idCardNo: [null, [Validators.required]],
			startUseDate: [null, [Validators.required]],
			endUseDate: [null, [Validators.required]],
			address: [null, [Validators.required]],
			driverType: [null, [Validators.required]],
			drivingStartUseDate: [null, [Validators.required]],
			drivingEndUseDate: [null, [Validators.required]],
			sex: [null],
			birthDate: [null],
			idCardNoFront: [null],
			idCardNoBack: [null],
			qualificationCertNo: [null, [Validators.required]],
			qualificationCertIssueAreaCode:[null, [Validators.required]],
			qualificationCertExpireTime: [null],
			issuingOrganizations: [null],
			drivingLicensePhoto: [null],
			qualificationCertPhoto: [null],
			remark: [null],
			truckid: [null]
		});


		this.validateFormPhone = this.fb.group({
			idCardNo: [null, [Validators.required]],
			address: [null],
			realname: [null],
			sex: [null],
			card: [null],
			birthDate: [null],
			idCardImgName: [null]
		});

		// 导出表单
		this.exportForm = this.fb.group({
			exportTemplateType: [null],
			isMemberTruck: [0]  // 车辆来源：0-网货，1-会员，2-商城
		});

		// 初始化车辆来源下拉列表
		this.truckSourceList = [
			{ label: '网货', value: 0 },
			{ label: '会员', value: 1 },
			{ label: '商城', value: 2 }
		];

		this.searchForm = this.fb.group({
			startTime: [null],
			endTime: [null],
			plateNumber: [null],
			plateNumbers: [null],
			checkFlag: [null],
			cusId: [null],
			agentId: [null],
			useStatus: [null],
			teamId: [null],
			ownName: [null],
			id: [null],
			isMemberTruck:[null],
			certificateExpiredCount:[null]
		});




		this.validateRelTeamTruckForm = this.fb.group({
			teamId: [null, [Validators.required]],
		});

		//司机关联托运方表单
		this.validateRelDriverForm = this.fb.group({
			cusId: [null, [Validators.required]],
		});

		this.validateRelTruckForm = this.fb.group({
			agentId: [null, [Validators.required]],
		});

		this.buttonAuthForm = this.fb.group({
			menuname: [null, [Validators.required]],
			icon: [null,],
			link: [null,],
			buttonId: [null, [Validators.required]],
		});

		this.checksTruckForm = this.fb.group({
			checkFlag: [null],
			checkLog: [null]
		});

		// 锁定车主收款表单
		this.lockTeamForm = this.fb.group({
			lockTeam: [null]
		});

		//加载代码表
		this.httpHelp.get('psg/diction/dicType',
			{ dicTypes: 'vehicle_classification_code,plate_color,energy_type,is_personal,use_character,truck_length,truck_type,political_outlook,driving_license' }).then(res => {
				if (res['status'] == 'success') {
					this.vehicleTypeMap = {};
					this.plateColorMap = {};
					const tempGoodsTypeList = res['data'];
					that.truckSizeLists.push({
						value: '',
						label: '请选择车长',
					})
					that.truckModelLists.push({
						value: '',
						label: '请选择车型',
					})

					that.energyTypeLists.push({
						value: '',
						label: '请选择',
					})
					that.vehicleTypeList.push({
						value: '',
						label: '请选择',
					})


					tempGoodsTypeList.forEach(e => {
						//车辆类型
						if (e['dicType'] == 'vehicle_classification_code') {
							this.vehicleTypeMap[e['value']] = e['text'];
							this.vehicleTypeList.push({
								label: e['text'],
								value: e['value']
							})
						}
						//车牌颜色
						if (e['dicType'] == 'plate_color') {
							this.plateColorMap[e['value']] = e['text'];
							this.plateColorLists.push({
								label: e['text'],
								value: e['value']
							})
						}
						//车辆能源类型
						if (e['dicType'] == 'energy_type') {
							this.energyTypeMap[e['value']] = e['text'];
							this.energyTypeLists.push({
								label: e['text'],
								value: e['value']
							})
						}
						// //政治面貌
						if (e['dicType'] == 'political_outlook') {
							//政治面貌
							this.politicalOutlookMap[e['value']] = e['text'];
							this.politicalOutlookLists.push({
								label: e['text'],
								value: e['value']
							})
						}

						// //政治面貌
						if (e['dicType'] == 'driving_license') {
							//政治面貌
							this.driverTypeMap[e['value']] = e['text'];
							this.driverTypeList.push({
								label: e['text'],
								value: e['value']
							})
						}
						//车辆属性
						if (e['dicType'] == 'is_personal') {
							this.isPersonalMap[e['value']] = e['text'];
							this.isPersonalLists.push({
								label: e['text'],
								value: e['value']
							})
						}
						//使用性质
						if (e['dicType'] == 'use_character') {
							this.useCharacterMap[e['value']] = e['text'];
							this.useCharacterLists.push({
								label: e['text'],
								value: e['value']
							})
						}
						//车长
						if (e['dicType'] == 'truck_length' && e['text'] != '任意车长') {
							this.truckSizeMap[e['value'] + ''] = e['text'];
							this.truckSizeLists.push({
								label: e['text'],
								value: e['value'] + ''
							})
						}
						//车型
						if (e['dicType'] == 'truck_type' && e['text'] != '全部车型') {
							this.truckModelMap[e['value']] = e['text'];
							this.truckModelLists.push({
								label: e['text'],
								value: e['value']
							})
						}
					})
				} else {
				}
			});
		this.httpHelp.get('psg/agent/query-agent-list', {}).then(res => {
			if (res['status'] == 'success') {
				this.agentMap = {};
				const tempAgentIdList = res['data'];
				tempAgentIdList.forEach(e => {
					this.agentMap[e['id']] = e['agentName'];
					this.agentIdList.push({
						label: e['agentName'],
						value: e['id']
					});
				});
				this.searchAgentList = this.getLocalDropdown(this.agentMap, true);
				// this.agentIdList = this.getLocalDropdown(this.shipperMap, false);
			} else {
				// this.showMessage()
			}
		});

		this.httpHelp.get('psg/shipper/query-cust-list', {}).then(res => {
			if (res['status'] == 'success') {
				this.shipperMap = {};
				const tempShipperIdList = res['data'];
				tempShipperIdList.forEach(e => {
					this.shipperMap[e['id']] = e['name'];
					this.shipperIdList.push({
						label: e['name'],
						value: e['id']
					});
				});
				this.searchShipperList = this.getLocalDropdown(this.shipperMap, true);
				this.ShipperList = this.getLocalDropdown(this.shipperMap, false);

			} else {
				// this.showMessage()
			}
		});

		this.httpHelp.get('psg/trucks/get-plateNumber', {}).then(res => {
			if (res['status'] == 'success') {
				this.plateNumberMap = {};
				this.plateNumberList = [];
				const tempShipperIdList = res['data']['plateNumbers'];
				tempShipperIdList.forEach(e => {
					this.plateNumberMap[e['id']] = e['plateNumber'];
					// this.plateNumberList.push({
					//   label: e['plateNumber'],
					//   value: e['id']
					// });
				});
				this.plateNumberList = this.getLocalDropdown(this.plateNumberMap, true);
			} else {
				// this.showMessage()
			}
		});

		this.httpHelp.get('psg/team/get-teamById', {}).then(res => {
			if (res['status'] == 'success') {
				this.teamIdMap = {};
				this.teamList = [];
				const tempShipperIdList = res['data']['teams'];
				tempShipperIdList.forEach(e => {
					this.teamIdMap[e['id']] = e['realname'];
					// this.plateNumberList.push({
					//   label: e['plateNumber'],
					//   value: e['id']
					// });
				});
				this.teamList = this.getLocalDropdown(this.teamIdMap, true);
				// console.log(this.plateNumberList)
			} else {
				// this.showMessage()
			}
		});

		this.httpHelp.get('psg/team/get-team', {}).then(res => {
			if (res['status'] == 'success') {
				this.teamMap = {};
				const tempTeamList = res['data']['pageList'];
				tempTeamList.forEach(e => {
					this.teamMap[e['id']] = e['realname'];
				});
			} else {
				// this.showMessage()
			}
		});

		// //车主信息
		// this.httpHelp.get('psg/team/get-team', { }).then(res => {
		//   if (res['status'] == 'success') {
		//     const tempShipperIdList = res['data']['pageList'];
		//     that.teamIdList.push({
		//       value: '',
		//       label: '请选择车主',
		//     })
		//     tempShipperIdList.forEach(e => {
		//       this.teamIdList.push({
		//         label: e['realname'],
		//         value: e['id']
		//       });
		//     });

		//   } else {
		//     // this.showMessage()
		//   }
		// });

		that.searchFormName = {
			startTime: { show: true, label: '开始时间' },
			endTime: { show: true, label: '截至时间' },
			plateNumber: { show: true, label: '车牌号' },
			ownName: { show: true, label: '业户名称' },
			useStatus: { show: true, label: '使用状态' },
			cusId: { show: true, label: '托运方' },
			teamId: { show: true, label: '车主' },
			agentId: { show: true, label: '区域合伙人' },
			plateNumbers: { show: true, label: '批量车牌号' },
		};

		super.initSearch(this, this.searchForm, [], [], true);

		// this.queryList();
		
		super.setScroll(this.router, 'carryManager/truck/truck.html', this.el);
		this.route.queryParamMap.subscribe((params) => {
      console.log("ssss", params.get("certificateExpiredCount"),params.get("isMemberTruck"));
      if (params.get("certificateExpiredCount") !== null) {
        this.changeCertificateExpiredCountItems(Number(params.get("certificateExpiredCount")),false);
				this.changeIsMemberTruckItemStatus(String(params.get("isMemberTruck")),false);
      } else {
        this.changeCertificateExpiredCountItems("",false);
				this.changeIsMemberTruckItemStatus("",false)
      }
    });
		this.changeSearchStatus('');
		this.getAreaList()
	}

	// ==================================查询部分设置==================================== //
	chearchFormObserver = null;
	searchItems = [];
	searchFormName = {};
	@ViewChild("truckSearchPanel") searchPanel : ElementRef;
	resetQuery() {
		this.getPlateNumber1();
		this.getTeamId1()
		this.searchForm.reset();
		this.batchNoForm.reset();
		super.initSearch(this, this.searchForm, [], [], true);
		this.hideSearchValue = [];
		this.isMemberTruckItem.forEach(e => {
			if (e.value === '') {
				e.checkFlag = true;
			} else {
				e.checkFlag = false;
			}
		});
		this.statusItems.forEach(e => {
			if (e.value === '') {
				e.checkFlag = true;
			} else {
				e.checkFlag = false;
			}
		});
		this.certificateExpiredCountItems.forEach(e => {
			if (e.value === '') {
				e.checkFlag = true;
			} else {
				e.checkFlag = false;
			}
		});
		this.queryList();
	}

	showEsQuery() {
		this.showEsSearch = !this.showEsSearch;
		const that = this;
		if (this.showEsSearch) {
			that.searchItems.forEach(e => {
				e.show = true;
			});
			for (let key in that.searchFormName) {
				that.searchFormName[key]['show'] = true;
			}
			this.hideSearchValue = [];
		} else {
			that.resetFormItem();
		}
	}

	deleteEsQuery(item) {
		this.hideSearchValue = this.hideSearchValue.filter(e => e.key != item.key);
		this.searchForm.get(item['key']).setValue(null);
	}

	ngAfterViewInit() : void {
		const that = this;
		let formItems = [];
		formItems = Array.from(that.searchPanel.nativeElement.querySelectorAll('form >.form-item'));
		formItems.forEach(item => {
			that.searchItems.push({
				name: item.getAttribute('name'),
				show: true,
				width: item.offsetWidth + 21    //
			});
		});
		that.resetFormItem();
	}

	formResize(event) {
		if (!this.showEsSearch) {
			this.resetFormItem(event.newRect.width);
		}
	}
	insProvinceList = []
    insCityList = []
	resetFormItem(width ?) {
		const that = this;
		let currFormWidth = 0;   // 变化后得宽度
		if (width) {
			currFormWidth = width;
		} else {
			let form = that.searchPanel.nativeElement.querySelector('form');
			currFormWidth = form.offsetWidth;
		}

		let currFormItemsWidth = 0;
		this.searchItems.forEach(e => {  // 计算显示宽度
			if (e['show']) {
				currFormItemsWidth += e.width;
			}
		});

		if (currFormItemsWidth > currFormWidth) {
			for (let i = that.searchItems.length - 1; i >= 0; i--) {
				if (that.searchItems[i].show) {
					that.searchItems[i].show = false;
					if (currFormWidth > currFormItemsWidth - that.searchItems[i].width) {
						break;
					}
					currFormItemsWidth -= that.searchItems[i].width;
				}
			}
		} else {
			for (let i = 0; that.searchItems.length > i; i++) {
				if (!that.searchItems[i].show) {
					if (currFormWidth > currFormItemsWidth + that.searchItems[i].width) {
						that.searchItems[i].show = true;
					}
					break;
				}
			}
		}
		this.hideSearchValue = [];
		that.searchItems.forEach(i => {
			that.searchFormName[i.name].show = i.show;
			if (!i.show) {
				if (that.searchForm.get(i.name).value || that.searchForm.get(i.name).value == 0) {
					this.hideSearchValue.push({
						key: i.name,
						value: that.keysFunction[i.name] ? that.keysFunction[i.name].format(that.searchForm.get(i.name).value) : that.searchForm.get(i.name).value,
						label: that.searchFormName[i.name].label
					});
				}
			}
		});
	}
	// ==================================查询部分设置结束==================================== //
	 getAreaList() {
        this.httpHelp.get('psgsys/sj/areainfo/getAreaList?pAreaCode=0' + '&provinceName=', {}).then(res => {
            if (res['code'] === 0) {
                // this.validateTruckForm.patchValue({
                //     insureCity: ''
                // })
                this.insProvinceList = [
                    {
                        label: '--请选择--',
                        value: ''
                    }
                ]
                const list = res['data'];
                list.forEach(e => {
                    this.insProvinceList.push({
                        label: e['areaName'],
                        value: e['areaCode']
                    });

                });
               
            } else {
               
                this.showMessage(this.messageSub, res['message'], 'error');
            }
        });
    }
    changeinsProvinceList(data) {

    if (data.value == 0) {
      return;
    }
    return this.httpHelp.get('psgsys/sj/areainfo/getAreaList?pAreaCode=' + data.value + '&provinceName=', {}).then(res => {
      if (res['code'] === 0) {
       
        this.insCityList = [{
          label: '--请选择--',
          value: ''
        }];
        const list = res['data'];
        list.forEach(e => {
          this.insCityList.push({
            label: e['areaName'],
            value: e['areaCode']
          });

        });


      } else {
        this.showMessage(this.messageSub, res['message'], 'error');
      }
    });
  }
	changeCertificateExpiredCountItems(checkValue,getList = true) {
    let that = this;
    this.certificateExpiredCountItems.forEach((e) => {
      if (e.value === checkValue) {
        e.checkFlag = true;
      } else {
        e.checkFlag = false;
      }
    });
    this.searchForm.patchValue({
      certificateExpiredCount: checkValue,
    });
		if(getList){
			 this.queryList();
		}
   
  }
	 certificateExpiredCountItems = [
    {
      label: "全部",
      value: "",
      checkFlag: true,
    },
    {
      label: "已过期",
      value: 1,
      checkFlag: false,
    },
  ];

}
